/**
 * MW Customizer — editor logic for sections/mw-product-customizer.liquid.
 * Gate 4: Fabric v6 canvas with template-derived geometry + overlay.
 * Fabric.js PINNED at v6.9.1, self-hosted at assets/fabric.min.js, loaded only
 * by the customizer section (see CLAUDE.md customizer exception). v6 API is
 * Promise-based — never mix v5 callback calls in here.
 *
 * Geometry rule: ALL print/case geometry derives from the template image's
 * natural dimensions (currently 2300x3900 = the exact print file spec).
 * Nothing print-related is hard-coded in JS.
 *
 * Config contract (shop.metafields.mw_customizer.config, json):
 *   { types: [{ slug, availability, variant_id, output_type,
 *       brands: [{ slug, availability, variant_id,
 *         models: [{ slug, availability, variant_id, template_url, mask_url }] }] }] }
 *   variant_id cascades: deepest non-null wins. availability:false at any
 *   level hides the node. template_url/mask_url may be bare theme-asset
 *   filenames (resolved against data-asset-base) or absolute URLs.
 */
(function () {
  'use strict';
  if (customElements.get('mw-customizer')) return;

  var log = function () {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[MW Customizer]');
    console.log.apply(console, args);
  };

  /* Text options. Families are self-hosted (snippets/mw-customizer-fonts.liquid);
     `tamil: true` marks the families with real Tamil glyph coverage. */
  var FONT_CATEGORIES = [
    { id: 'tamil', label: 'Tamil' },
    { id: 'superhero', label: 'Superhero' },
    { id: 'curly', label: 'Curly' },
    { id: 'signature', label: 'Signature' },
    { id: 'bold', label: 'Bold' },
    { id: 'clean', label: 'Clean' }
  ];

  /* Order here is the order chips render in; `cat` groups them behind the
     category row. `thin: true` marks faces whose strokes are fine enough to
     break up in print, which sets a higher minimum size (MIN_TEXT_SCALE_THIN).
     A category's fonts only download when its chips are shown — the chips are
     `hidden` otherwise, and a browser fetches no font for an unrendered node. */
  var FONTS = [
    { label: 'Catamaran', css: 'MW Catamaran', weight: 700, tamil: true, cat: 'tamil' },
    { label: 'Mukta Malar', css: 'MW Mukta Malar', weight: 700, tamil: true, cat: 'tamil' },
    { label: 'Baloo Thambi', css: 'MW Baloo Thambi', weight: 700, tamil: true, cat: 'tamil' },
    { label: 'Arima', css: 'MW Arima', weight: 700, tamil: true, cat: 'tamil' },

    { label: 'Bangers', css: 'MW Bangers', weight: 400, tamil: false, cat: 'superhero' },
    { label: 'Luckiest Guy', css: 'MW Luckiest Guy', weight: 400, tamil: false, cat: 'superhero' },
    { label: 'Titan One', css: 'MW Titan One', weight: 400, tamil: false, cat: 'superhero' },

    { label: 'Lobster', css: 'MW Lobster', weight: 400, tamil: false, cat: 'curly' },
    { label: 'Pacifico', css: 'MW Pacifico', weight: 400, tamil: false, cat: 'curly' },
    { label: 'Yellowtail', css: 'MW Yellowtail', weight: 400, tamil: false, cat: 'curly' },

    { label: 'Great Vibes', css: 'MW Great Vibes', weight: 400, tamil: false, cat: 'signature', thin: true },
    { label: 'Sacramento', css: 'MW Sacramento', weight: 400, tamil: false, cat: 'signature', thin: true },

    { label: 'Anton', css: 'MW Anton', weight: 400, tamil: false, cat: 'bold' },
    { label: 'Bebas Neue', css: 'MW Bebas Neue', weight: 400, tamil: false, cat: 'bold' },

    { label: 'Poppins', css: 'MW Poppins', weight: 700, tamil: false, cat: 'clean' },
    { label: 'Inter', css: 'MW Inter', weight: 700, tamil: false, cat: 'clean' }
  ];

  /* Clean/Poppins is the default: it reads well in English, and typing Tamil
     auto-switches to a Tamil face anyway (see _syncFontAvailability). */
  var DEFAULT_FONT = FONTS[14];

  var COLOURS = [
    '#ffffff', '#000000', '#e6b422', '#c0392b', '#e84393',
    '#2980b9', '#16a085', '#8e44ad', '#e67e22', '#7f8c8d'
  ];

  /* Preset styles: fill/stroke/shadow combinations applied on top of the
     chosen colour. `useColour` false means the preset owns the fill. */
  var STYLES = [
    { id: 'plain', label: 'Plain' },
    { id: 'outline', label: 'Outline', stroke: '#000000', strokeWidth: 0.055 },
    { id: 'white-edge', label: 'White edge', stroke: '#ffffff', strokeWidth: 0.055 },
    { id: 'shadow', label: 'Shadow', shadow: 'rgba(0,0,0,0.55) 0 4px 10px' },
    { id: 'glow', label: 'Glow', shadow: 'rgba(255,255,255,0.9) 0 0 14px' },
    { id: 'lift', label: 'Lift', stroke: '#000000', strokeWidth: 0.035, shadow: 'rgba(0,0,0,0.5) 0 6px 12px' },
    { id: 'wide', label: 'Wide', charSpacing: 260 },
    { id: 'tight', label: 'Tight', charSpacing: -40 }
  ];

  /* Print safety. Text below these scales prints mushy on glass; thin
     signature faces need more headroom than solid ones. Enforced as a floor on
     the Adjust size control, not as a warning the customer can ignore. */
  var MIN_TEXT_SCALE = 0.55;
  var MIN_TEXT_SCALE_THIN = 0.8;
  var MAX_TEXT_SCALE = 2.4;

  /* Chip previews show the customer's own text; longer names are trimmed so
     the chips stay one row. */
  var CHIP_PREVIEW_CHARS = 9;

  /* Artwork reaches this fraction past the case on every side, so there is
     margin to trim into at print instead of the design stopping dead on the
     edge. ~2% of 3900 print px is about 3mm. Override per model with
     `mockup_bleed` in the shop config. */
  var DEFAULT_BLEED = 0.02;

  /* Faded overflow bands, outermost first. `grow` is a fraction of the room
     between the case and the canvas edge, so every band stays inside the canvas
     and keeps its rounded outline. Opacities accumulate where bands overlap,
     giving roughly 100% on the case, then 64%, 28%, 8% going out. */
  var OVERFLOW_BANDS = [
    { grow: 1.00, opacity: 0.08 },
    { grow: 0.68, opacity: 0.22 },
    { grow: 0.35, opacity: 0.50 }
  ];

  /* Zoom limits for the photo. Deliberately absolute — a limit derived from
     the case would make the case a cage. The image is a free layer; the case
     mask only decides what part of it is visible. Small enough to shrink well
     inside the case, large enough to guard against runaway memory. */
  var PHOTO_MIN_SCREEN_PX = 36;
  var PHOTO_MAX_SCREEN_PX = 6000;

  function defaultAdjust() {
    return { scale: 1, spacing: 0, align: 'center', angle: 0 };
  }

  var TEXT_MAX_CHARS = 40;
  var TEXT_MAX_LINES = 3;

  /* While something is selected the case mockup ghosts back so the customer
     can see the parts of their design that fall outside the printed area.
     The reference implementation uses 0.25, but its case art is translucent
     to begin with; ours has an opaque surround, so 0.25 washes the case out
     entirely. 0.45 shows the overhang while keeping the case readable. */

  /* Above this, the raw original is re-encoded before upload (see
     _originalForUpload) so a huge DSLR file can't stall or fail checkout. */
  var MAX_ORIGINAL_BYTES = 10 * 1024 * 1024;

  /* Reservation for the editor tool panel before it has ever been measured. */
  var MOBILE_EDIT_CHROME_FALLBACK = 96;

  var _webp = null;
  var supportsWebp = function () {
    if (_webp !== null) return _webp;
    try {
      var c = document.createElement('canvas');
      _webp = c.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } catch (err) {
      _webp = false;
    }
    return _webp;
  };

  var TAMIL_RE = /[஀-௿]/;

  /* Tamil letters are multiple code units (வ + ண + ் = one letter to a
     reader). Counting/slicing by code unit would give Tamil customers ~2/3
     the allowance and could cut a letter apart, so count graphemes. */
  var segmenter = (typeof Intl !== 'undefined' && Intl.Segmenter)
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    : null;

  var graphemes = function (str) {
    if (!segmenter) return Array.from(str);
    var out = [];
    var it = segmenter.segment(str)[Symbol.iterator]();
    for (var s = it.next(); !s.done; s = it.next()) out.push(s.value.segment);
    return out;
  };

  var countGraphemes = function (str) { return graphemes(str).length; };

  var sliceGraphemes = function (str, max) {
    var g = graphemes(str);
    return g.length <= max ? str : g.slice(0, max).join('');
  };

  class MWCustomizer extends HTMLElement {
    connectedCallback() {
      // The theme editor (and any DOM move) can reconnect the same instance;
      // a second init would append a duplicate canvas into the stage.
      if (this._connectedOnce) {
        log('reconnect ignored (already initialized)');
        return;
      }
      this._connectedOnce = true;
      this._statusEl = this.querySelector('[data-mw-cz-status]');
      this._stageEl = this.querySelector('[data-mw-cz-stage]');
      this._loadingEl = this.querySelector('[data-mw-cz-loading]');
      try {
        this._init();
      } catch (err) {
        log('init failed', err);
        this._fail('Could not start the customizer. Please refresh the page.');
      }
    }

    _init() {
      var cfgEl = this.querySelector('[data-mw-cz-config]');
      var config = null;
      try {
        config = cfgEl ? JSON.parse(cfgEl.textContent) : null;
      } catch (err) {
        log('config JSON parse error', err);
      }
      if (!config || !Array.isArray(config.types)) {
        return this._fail('The customizer is not configured yet.');
      }

      var node = this._resolvePath(config, this.dataset.configPath || '');
      if (!node) {
        return this._fail('This model is currently unavailable for customization.');
      }

      var variantInput = this.querySelector('[data-mw-cz-variant]');
      if (node.variant_id && variantInput &&
          String(node.variant_id) !== String(variantInput.value)) {
        // Config and product disagree; the product on this page is authoritative,
        // but flag it loudly because it means the config is stale.
        log('WARNING: config variant_id', node.variant_id,
          '!= product variant', variantInput.value, '- using product variant');
      }

      node.template_src = this._resolveUrl(node.template_url);
      node.mask_src = this._resolveUrl(node.mask_url);
      // WebP mockup is ~1/12th the size; fall back for browsers without it.
      var preferred = supportsWebp() ? node.mockup_url : (node.mockup_fallback_url || node.mockup_url);
      node.mockup_src = this._resolveUrl(preferred) || this._resolveUrl(node.mockup_fallback_url);
      if (!node.mockup_src) {
        return this._fail('Customizer template missing. Please try again later.');
      }

      // The order's Phone Model / Case Type come from the resolved node, not
      // from markup — one template serves every model, so anything hardcoded in
      // the section would be wrong for all but one of them.
      var pm = this.querySelector('[data-mw-cz-prop-phone-model]');
      var ct = this.querySelector('[data-mw-cz-prop-case-type]');
      if (pm) pm.value = node.model_title || '';
      if (ct) ct.value = node.type_title || '';

      this.czConfig = node;
      this._initCanvas(node);
    }

    /** Walks type/brand/model by slug, cascading variant_id and output_type. */
    _resolvePath(config, pathStr) {
      var path = pathStr.split('/').filter(Boolean);
      if (path.length !== 3) { log('bad config_path', pathStr); return null; }
      var norm = function (s) {
        return String(s || '').toLowerCase().trim().replace(/\s+/g, '_');
      };
      var find = function (list, slug) {
        if (!Array.isArray(list)) return null;
        for (var i = 0; i < list.length; i++) {
          if (norm(list[i].slug) === norm(slug)) return list[i];
        }
        return null;
      };
      var type = find(config.types, path[0]);
      if (!type || type.availability === false) return null;
      var brand = find(type.brands, path[1]);
      if (!brand || brand.availability === false) return null;
      var model = find(brand.models, path[2]);
      if (!model || model.availability === false) return null;

      return {
        type_title: type.title,
        brand_title: brand.title,
        model_title: model.title,
        output_type: model.output_type || brand.output_type || type.output_type || 'jpg',
        print_dpi: model.print_dpi || brand.print_dpi || type.print_dpi || 300,
        // Explicit print size. Previously derived from the mockup's natural
        // width, which silently coupled print output to the DISPLAY asset —
        // optimising the mockup would have changed every print file.
        print_width: model.print_width || brand.print_width || type.print_width || null,
        print_height: model.print_height || brand.print_height || type.print_height || null,
        mockup_fallback_url: model.mockup_fallback_url,
        variant_id: model.variant_id || brand.variant_id || type.variant_id || null,
        template_url: model.template_url,
        mask_url: model.mask_url,
        mockup_url: model.mockup_url,
        // Where the printable artwork sits inside the mockup image, as
        // fractions of the mockup. Print dimensions derive from this.
        mockup_art_rect: model.mockup_art_rect,
        // How far the artwork reaches past the case, as a fraction of the
        // artwork on each side. Tunable per model from the shop metafield.
        mockup_bleed: model.mockup_bleed
      };
    }

    _resolveUrl(url) {
      if (!url) return null;
      // Absolute AND protocol-relative (//cdn.shopify.com/...) pass through.
      if (/^(https?:)?\/\//.test(url)) return url;
      // Prefer the Liquid-built map: those URLs carry asset_url's ?v= hash,
      // so re-pushed assets are never served stale from CDN cache.
      var map = this._assetMap();
      if (map && map[url]) return map[url];
      return (this.dataset.assetBase || '') + url;
    }

    _assetMap() {
      if (this._assetMapCache !== undefined) return this._assetMapCache;
      var el = this.querySelector('[data-mw-cz-assets]');
      try {
        this._assetMapCache = el ? JSON.parse(el.textContent) : null;
      } catch (err) {
        log('asset map parse failed', err);
        this._assetMapCache = null;
      }
      return this._assetMapCache;
    }

    /** Fabric v6 canvas: sized from the stage box, aspect + export geometry
     *  derived from the template image's natural dimensions. */
    _initCanvas(node) {
      var self = this;
      if (!window.fabric || !window.fabric.Canvas) {
        log('fabric global missing');
        return this._fail('Could not load the editor. Please refresh the page.');
      }

      // The mockup IS the case (bezel, camera, gloss, opaque white surround)
      // with the print window punched transparent — authored from the PSD.
      // Print geometry derives from it plus the artwork rect: nothing about
      // the case or the print area is hard-coded here.
      var rect = node.mockup_art_rect || { x0: 0, y0: 0, x1: 1, y1: 1 };
      window.fabric.FabricImage.fromURL(node.mockup_src, { crossOrigin: 'anonymous' })
        .then(function (mockupImg) {
          self._mockupW = mockupImg.width;
          self._mockupH = mockupImg.height;
          self._artRect = rect;
          self._bleed = typeof node.mockup_bleed === 'number'
            ? Math.max(0, Math.min(0.12, node.mockup_bleed))
            : DEFAULT_BLEED;
          // Print size comes from config; the mockup is a DISPLAY asset and
          // must never dictate print output. Derivation is the fallback only.
          self._templateW = node.print_width || Math.round(mockupImg.width * (rect.x1 - rect.x0));
          self._templateH = node.print_height || Math.round(mockupImg.height * (rect.y1 - rect.y0));
          return self._whenStageMeasurable().then(function () {
            self._buildCanvas(mockupImg);
          });
        })
        .catch(function (err) {
          log('mockup load failed', node.mockup_src, err);
          self._fail('Could not load the case template. Please refresh.');
        });
    }

    /** Stage may measure 0 while CSS applies or while the tab is hidden.
     *  Ticks on setTimeout, NOT requestAnimationFrame — rAF is suspended in
     *  hidden/backgrounded tabs, which would stall the build forever even
     *  after layout becomes valid. Waits up to ~30s, then resolves anyway
     *  (the resize-factor guard makes a 0-size build recoverable). */
    _whenStageMeasurable() {
      var self = this;
      return new Promise(function (resolve) {
        var tries = 0;
        (function check() {
          if (self._destroyed) return resolve();
          if (self._stageEl.clientHeight > 100 || tries > 500) return resolve();
          tries += 1;
          setTimeout(check, 60);
        })();
      });
    }

    /** The canvas = artwork area + a workspace gutter on all sides. The
     *  gutter is where selection handles live (a cover-fit photo's corners
     *  sit exactly on the artwork bounds — without a gutter they'd be
     *  unreachable). Artwork aspect always derives from the template. */
    _gutterFor(artH) {
      return Math.round(Math.min(64, Math.max(36, artH * 0.085)));
    }

    /** Actual height of the mobile editor's chrome (top bar + tool panel).
     *  The panel only exists while something is selected, so its height is
     *  remembered and reused as the reservation when it is hidden — that
     *  keeps the case a constant size instead of jumping on every select. */
    _editChromeHeight() {
      var bar = this.querySelector('.mw-cz__editbar');
      var ctx = this._contextEl;
      var barH = bar ? bar.getBoundingClientRect().height : 0;
      if (ctx && !ctx.hidden) {
        var h = ctx.getBoundingClientRect().height;
        if (h > 0) this._ctxHeight = h;
      }
      return Math.round(barH + (this._ctxHeight || MOBILE_EDIT_CHROME_FALLBACK) + 16);
    }

    /** Content is clipped to the artwork region so nothing spills into the
     *  handle gutter (a cover-fit photo usually overflows one axis). */
    /** The full print rectangle. Used for the print export, which must be
     *  rectangular artwork edge to edge (NBE spec). */
    _artClip() {
      var art = this._art;
      return new window.fabric.Rect({
        left: art.x, top: art.y, width: art.w, height: art.h,
        absolutePositioned: true
      });
    }

    /** The case shape, for DISPLAY. Artwork used to be clipped to the artwork
     *  rectangle and masked by the mockup's opaque white surround — which is
     *  why a square showed around the case. Clipping to the case itself means
     *  nothing is ever drawn outside it and no masking layer is needed.
     *
     *  Padded outward slightly so the artwork tucks UNDER the bezel: two
     *  antialiased edges meeting exactly is what produced the earlier hairline.
     *  The camera needs no clip — the mockup draws it over the artwork.
     *
     *  Falls back to the print rectangle when the mask scan has not landed yet
     *  (it is async and a photo can be dropped first); _refreshClips upgrades
     *  those objects once the geometry arrives. */
    _caseClip(grow) {
      var art = this._art;
      var g = this._guideGeom;
      var d = this._canvasDims;
      if (!g || !g.sil) return this._artClip();
      var w = (g.sil.x1 - g.sil.x0) * art.w;
      var h = (g.sil.y1 - g.sil.y0) * art.h;
      var left0 = art.x + g.sil.x0 * art.w;
      var top0 = art.y + g.sil.y0 * art.h;
      var base = w * 0.012;
      var pad = base;

      if (grow && d) {
        // `grow` is a fraction of the room left between the case and the edge
        // of the canvas, not of the case itself. A band wider than the canvas
        // gets cut off square by the canvas edge — a faint rectangle, which is
        // the artefact this whole approach exists to avoid.
        var room = Math.min(left0, top0, d.w - left0 - w, d.h - top0 - h) - 2;
        pad = base + grow * Math.max(0, room - base);
      }

      return new window.fabric.Rect({
        left: left0 - pad,
        top: top0 - pad,
        width: w + 2 * pad,
        height: h + 2 * pad,
        rx: g.radius * art.w + pad,
        ry: g.radius * art.w + pad,
        absolutePositioned: true
      });
    }

    /** Soft faded overflow, shown only while the photo is selected.
     *
     *  Copies of the photo sit UNDER it, each clipped to the case shape grown
     *  outward by a little more and drawn a little fainter. Because every band
     *  is clipped to the case outline, the photo's own rectangle never appears
     *  as an edge — the thing that has to stay gone. The bands overlap, so the
     *  visible falloff is roughly 100% inside the case, then 64%, 28%, 8%.
     *
     *  Canvas objects render into exports regardless of excludeFromExport, so
     *  these are removed on deselect and hidden explicitly in exportDesign(). */
    _showOverflow() {
      var canvas = this.czCanvas;
      var photo = this._photoObj;
      if (!canvas || !photo || this._overflow) return;
      if (canvas.getActiveObject() !== photo) return;
      var el = photo.getElement && photo.getElement();
      if (!el) return;
      var self = this;
      this._overflow = OVERFLOW_BANDS.map(function (band) {
        var ghost = new window.fabric.FabricImage(el, {
          originX: 'center',
          originY: 'center',
          opacity: band.opacity,
          selectable: false,
          evented: false,
          excludeFromExport: true
        });
        ghost.clipPath = self._caseClip(band.grow);
        canvas.add(ghost);
        canvas.sendObjectToBack(ghost);   // always beneath the real photo
        return ghost;
      });
      this._syncOverflow();
    }

    _syncOverflow() {
      var photo = this._photoObj;
      if (!this._overflow || !photo) return;
      this._overflow.forEach(function (ghost) {
        ghost.set({
          left: photo.left, top: photo.top,
          scaleX: photo.scaleX, scaleY: photo.scaleY,
          angle: photo.angle,
          originX: photo.originX, originY: photo.originY
        });
        ghost.setCoords();
      });
    }

    _hideOverflow() {
      var canvas = this.czCanvas;
      if (!this._overflow || !canvas) return;
      this._overflow.forEach(function (ghost) { canvas.remove(ghost); });
      this._overflow = null;
      canvas.requestRenderAll();
    }

    /** Re-clips artwork to the current geometry. Called when the mask scan
     *  completes and after a resize. */
    _refreshClips() {
      var self = this;
      var canvas = this.czCanvas;
      if (!canvas) return;
      canvas.getObjects().forEach(function (obj) {
        if (obj.clipPath && obj.clipPath.absolutePositioned) obj.clipPath = self._caseClip();
      });
      canvas.requestRenderAll();
    }

    /** Scales/positions the mockup so its artwork rect lands exactly on the
     *  canvas artwork region — the case then sits where it really is
     *  relative to the print area, at the PSD's true proportions. */
    _positionMockup() {
      var ov = this._mockupObj;
      var art = this._art;
      var r = this._artRect;
      if (!ov || !art || !r) return;

      // Bleed. The mask scan puts the case window at the full height of the
      // artwork (sil.y0 = 0, sil.y1 = 1), so artwork and case edge coincide and
      // there is no margin to trim into. Treating the artwork as covering a
      // little MORE than the case draws the case slightly smaller inside it,
      // so the photo overhangs the edges instead of stopping on them.
      //
      // The export renders the artwork rect, which is untouched here — the
      // print file is identical with bleed on or off. This changes where the
      // case is drawn, not what is printed.
      var b = this._bleed || 0;
      var rw = r.x1 - r.x0;
      var rh = r.y1 - r.y0;
      var x0 = r.x0 - b * rw;
      var y0 = r.y0 - b * rh;
      var fullW = art.w / (rw * (1 + 2 * b));
      var fullH = art.h / (rh * (1 + 2 * b));
      ov.set({
        left: art.x - x0 * fullW,
        top: art.y - y0 * fullH,
        scaleX: fullW / this._mockupW,
        scaleY: fullH / this._mockupH
      });
    }

    /** Guides, the placeholder and the idle clip are all expressed as
     *  fractions of the ARTWORK, but they describe the CASE. Once the case is
     *  drawn inset by the bleed they have to move with it, or the dashed safe
     *  area would sit outside the case it belongs to. */
    _applyBleedToGeom(geom) {
      var b = this._bleed || 0;
      if (!geom || !b) return geom;
      var map = function (f) { return (b + f) / (1 + 2 * b); };
      var box = function (r) {
        return r ? { x0: map(r.x0), y0: map(r.y0), x1: map(r.x1), y1: map(r.y1) } : r;
      };
      return {
        sil: box(geom.sil),
        cam: box(geom.cam),
        radius: geom.radius / (1 + 2 * b)
      };
    }

    /** The stage box holds the whole canvas (case + gutter). Sizing it in JS
     *  keeps the case at its intended size instead of the gutter eating into
     *  a CSS-fixed height. */
    _syncStageBox(dims) {
      this._stageEl.style.width = dims.w + 'px';
      this._stageEl.style.height = dims.h + 'px';
    }

    /** Print dimensions reduced to their smallest whole-number ratio
     *  (2300x3900 -> 23:39). Sizing the artwork region in exact multiples of
     *  this ratio keeps the on-screen aspect EXACTLY equal to the print
     *  aspect, so the export multiplier lands on whole print pixels instead
     *  of drifting a few pixels short. */
    _printRatio() {
      if (this._ratioCache) return this._ratioCache;
      var a = this._templateW, b = this._templateH, t;
      while (b) { t = b; b = a % b; a = t; }
      var d = a || 1;
      this._ratioCache = { rw: this._templateW / d, rh: this._templateH / d };
      return this._ratioCache;
    }

    /** The CASE is the thing being sized — the gutter is added AROUND it, so
     *  adding the workspace never shrinks the case. Target case height comes
     *  from the viewport (same scale as the approved idle look); width is
     *  constrained by the column. Artwork aspect always from the template. */
    _computeCanvasSize() {
      var r = this._printRatio();

      // Measure the COLUMN, not the stage. The stage shrink-wraps its canvas,
      // so measuring it feeds the canvas's own width back into the calculation:
      // once the case shrank (keyboard up), the stage shrank with it and the
      // case could never grow back — it ratcheted down and stayed there, which
      // is why the case was tiny after typing. The column is sized by the
      // layout and never by the canvas, so it is a stable reference.
      var stageBox = this._stageEl.parentElement || this._stageEl;
      var col = this._stageEl.closest ? this._stageEl.closest('.mw-cz__stage-col') : null;
      var containerW = stageBox.clientWidth;
      if (col && col !== stageBox && col.clientWidth) {
        var cs = window.getComputedStyle(stageBox);
        containerW = col.clientWidth -
          ((parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0));
      }

      // In the mobile editor the stage is a fixed overlay, so its DOM parent
      // no longer describes the space available — measure the viewport,
      // leaving room for the top bar and the tool row.
      var sheet = this._mode === 'edit' && this._isNarrow();
      var targetH;
      var docked = this.classList.contains('is-docked')
        ? parseInt(this.style.getPropertyValue('--cz-dock-h'), 10) : 0;
      if (docked > 0) {
        // Typing: fit the case into the room the keyboard leaves.
        targetH = Math.max(120, docked - 16);
      } else if (sheet) {
        // Measure the real chrome instead of assuming it. A fixed guess left
        // the case running underneath the tool panel, so its bottom handles
        // could not be reached.
        targetH = Math.max(180, window.innerHeight - this._editChromeHeight());
      } else if (this._isNarrow()) {
        // Deliberately under half the screen: the customer must be able to
        // see there is more page below, and reach it without a fight.
        targetH = Math.min(window.innerHeight * 0.46, 420);
      } else {
        targetH = Math.min(window.innerHeight * 0.72, 700);
      }

      var k = Math.max(4, Math.round(targetH / r.rh));
      var artW = r.rw * k;
      var artH = r.rh * k;
      var g = this._gutterFor(artH);

      var availW = Math.min(
        sheet ? window.innerWidth : (containerW || artW + 2 * g),
        Math.round(window.innerWidth * 0.94)
      );
      // While docked, the dock is a hard ceiling: targetH sizes the CASE, but
      // what has to fit is the canvas, which is the case plus its gutter. Left
      // unbounded the canvas overflowed the dock and ran under the sheet — the
      // taller the sheet, the more of the case it swallowed.
      var availH = docked > 0 ? docked - 8 : Infinity;

      // Shrink in whole ratio steps so the aspect stays exact.
      var guard = 0;
      while ((artW + 2 * g > availW || artH + 2 * g > availH) &&
             availW > 0 && k > 4 && guard < 200) {
        k -= 1;
        artW = r.rw * k;
        artH = r.rh * k;
        g = this._gutterFor(artH);
        guard += 1;
      }
      return { w: artW + 2 * g, h: artH + 2 * g, artW: artW, artH: artH, g: g };
    }

    /** Exact print multiplier for this artwork size (whole print pixels). */
    _printMultiplier() {
      return this._templateW / this._art.w;
    }

    _buildCanvas(overlayImg) {
      // The template loads async — the element may have been torn down
      // (theme editor re-render, navigation) while the request was in flight.
      if (this._destroyed || !this.isConnected) {
        log('build skipped: element torn down during template load');
        return;
      }
      var dims = this._computeCanvasSize();
      var canvasEl = document.createElement('canvas');
      this._stageEl.appendChild(canvasEl);

      var canvas = new window.fabric.Canvas(canvasEl, {
        width: dims.w,
        height: dims.h,
        // Transparent: the page shows through around the case. The export
        // paints white for the print/preview passes and restores this.
        backgroundColor: '',
        selection: false,              // no multi-select / group transforms
        preserveObjectStacking: true,
        controlsAboveOverlay: true,
        enableRetinaScaling: true
      });

      // Artwork region inside the canvas — every placement/export references
      // this, and its aspect comes from the mockup's artwork rect.
      this._art = { x: dims.g, y: dims.g, w: dims.artW, h: dims.artH };

      overlayImg.set({ originX: 'left', originY: 'top', selectable: false, evented: false });
      this._mockupObj = overlayImg;
      canvas.overlayImage = overlayImg;
      this._positionMockup();
      canvas.requestRenderAll();

      this.czCanvas = canvas;
      this._canvasDims = dims;
      this._syncStageBox(dims);

      if (this._loadingEl) this._loadingEl.remove();
      this._stageEl.classList.add('mw-cz__case--ready');
      this._setStatus('');
      // The blank glass now says what goes there instead of reading as broken.

      this._onResize = this._debounce(this._handleResize.bind(this), 250);
      // Both signals, debounced into one handler with a same-size guard:
      // ResizeObserver catches layout-driven changes; window resize is the
      // fallback where RO is missing or not delivering.
      window.addEventListener('resize', this._onResize);
      if (typeof ResizeObserver === 'function') {
        this._resizeObserver = new ResizeObserver(this._onResize);
        this._resizeObserver.observe(this._stageEl);
      }

      this._bindUI();
      this._initGuides();

      log('canvas ready', {
        template: this._templateW + 'x' + this._templateH,
        canvas: dims.w + 'x' + dims.h,
        dpr: window.devicePixelRatio
      });
      this.dispatchEvent(new CustomEvent('mw-cz:ready', { detail: this.czConfig }));
    }

    /* ---------------- Gate 5: photo upload + controls ---------------- */

    _bindUI() {
      var self = this;
      var canvas = this.czCanvas;
      this._photoBtn = this.querySelector('[data-mw-cz-tool="image"]');
      this._fileInput = this.querySelector('[data-mw-cz-file]');
      this._zoomWrap = this.querySelector('[data-mw-cz-zoom]');
      this._hintEl = this.querySelector('[data-mw-cz-hint]');

      if (this._photoBtn && this._fileInput) {
        this._photoBtn.disabled = false;
        this._photoBtn.addEventListener('click', function () {
          self._fileInput.click();
        });
        this._fileInput.addEventListener('change', function () {
          self._onPhotoPicked(self._fileInput);
        });
      }

      this._bindTextUI();

      var zoomIn = this.querySelector('[data-mw-cz-zoom-in]');
      var zoomOut = this.querySelector('[data-mw-cz-zoom-out]');
      if (zoomIn) zoomIn.addEventListener('click', function () { self._zoomActive(1.08); });
      if (zoomOut) zoomOut.addEventListener('click', function () { self._zoomActive(1 / 1.08); });

      // Overflow preview follows the photo while it is being transformed.
      var syncGhost = function (opt) {
        if (opt && opt.target === self._photoObj) self._syncOverflow();
      };
      canvas.on('object:moving', syncGhost);
      canvas.on('object:scaling', syncGhost);
      canvas.on('object:rotating', syncGhost);
      canvas.on('object:modified', syncGhost);

      // Wheel = fine zoom on the selected object (±1% per tick, spec §A8).
      canvas.on('mouse:wheel', function (opt) {
        if (!canvas.getActiveObject()) return;
        opt.e.preventDefault();
        opt.e.stopPropagation();
        self._zoomActive(opt.e.deltaY < 0 ? 1.01 : 1 / 1.01);
      });

      // Two states, deliberately different:
      //   selected  — soft faded overflow, so the customer can see how much of
      //               their photo falls outside the case and how it will crop.
      //   deselected— hard clip to the case, the clean product preview.
      var enterEditing = function () {
        self._stageEl.classList.add('is-editing');
        self._setGuidesVisible(true);
        self._showOverflow();
        self._updateContextUI();
      };
      var leaveEditing = function () {
        self._stageEl.classList.remove('is-editing');
        self._setGuidesVisible(false);
        self._hideOverflow();
        self._updateContextUI();
      };
      canvas.on('selection:created', enterEditing);
      canvas.on('selection:updated', enterEditing);
      canvas.on('selection:cleared', leaveEditing);

      this._bindContextControls();
      this._bindTouchGestures();
      this._bindAddToCart();
      this._bindModeControls();
      this._bindKeyboardDock();
      this._setMode('browse');   // page must scroll freely until asked to edit
      this._updateSteps();

      // Cheap: just marks progress. Deliberately does NOT re-encode the
      // canvas — a toDataURL() here ran on every drag/resize and was the
      // main source of editor lag on mobile.
      canvas.on('object:modified', function () {
        self._touchedDesign = true;
        self._updateSteps();
      });

      // Resolution guard: warn (never block) as the photo is resized.
      this._dpiEl = this.querySelector('[data-mw-cz-dpi]');
      var refreshDpi = function () { self._updateDpiWarning(); };
      canvas.on('object:scaling', refreshDpi);
      canvas.on('object:modified', refreshDpi);

      // Clicking anything that isn't the canvas deselects (spec §A8) —
      // Fabric only sees clicks on its own canvas, and <mw-customizer>
      // spans both columns, so "inside the element" is not a useful test.
      // Only the canvas itself and controls that ACT on the selection
      // (zoom buttons) preserve it.
      this._onDocPointerDown = function (e) {
        if (!self.czCanvas || !self.czCanvas.getActiveObject()) return;
        var t = e.target;
        if (t.closest && (t.closest('.canvas-container') || t.closest('[data-mw-cz-zoom]'))) return;
        self.czCanvas.discardActiveObject();
        self.czCanvas.requestRenderAll();
        leaveEditing();
      };
      document.addEventListener('pointerdown', this._onDocPointerDown);
    }

    /* ---------------- Gate 9: upload + add to cart ---------------- */

    _bindAddToCart() {
      var self = this;
      this._form = this.querySelector('[data-mw-cz-form]');
      this._atcBtn = this.querySelector('[data-mw-cz-atc]');
      this._busyEl = this.querySelector('[data-mw-cz-busy]');
      if (!this._form || !this._atcBtn) return;

      this._form.addEventListener('submit', function (e) {
        e.preventDefault();          // never let it navigate away
        self._addToCart();
      });

      // Rights confirmation: unticked by default, records the tick time.
      this._rightsBox = this.querySelector('[data-mw-cz-rights]');
      this._gateHintEl = this.querySelector('[data-mw-cz-gate-hint]');
      if (this._rightsBox) {
        this._rightsBox.checked = false;   // never restore a stale tick
        this._rightsBox.addEventListener('change', function () {
          self._rightsConfirmedAt = self._rightsBox.checked ? new Date().toISOString() : null;
          self._refreshAtcState();
        });
      }
      this._refreshAtcState();
    }

    /**
     * The rights tick is a theme-editor block now, so it can legitimately be
     * absent. Treat "no checkbox on the page" as nothing to confirm — reading
     * _rightsConfirmedAt alone would leave Add to Cart disabled forever the
     * moment someone removed the block, which looks like a broken shop rather
     * than the policy change it actually is. Safe against ordering: _rightsBox
     * is queried in the same method that finds _atcBtn, and every caller here
     * bails out when _atcBtn is missing.
     */
    _rightsSatisfied() {
      return !this._rightsBox || !!this._rightsConfirmedAt;
    }

    /** ATC needs BOTH a design and the rights confirmation (Gate 10). */
    _refreshAtcState() {
      if (!this._atcBtn) return;
      var hasDesign = !!this._photoObj || !!this._textObj;
      var confirmed = this._rightsSatisfied();
      this._atcBtn.disabled = !hasDesign || !confirmed || !!this._saving;
      if (this._gateHintEl) {
        // Only nudge once they actually have something to add.
        this._gateHintEl.hidden = !(hasDesign && !confirmed && !this._saving);
      }
      if (this._editOpenBtn) this._editOpenBtn.hidden = !hasDesign;
      this._syncPlaceholder();
      this._updateSteps();
    }

    _setBusy(on, message) {
      this._saving = on;
      if (this._busyEl) {
        this._busyEl.hidden = !on;
        if (message) this._busyEl.textContent = message;
      }
      this.classList.toggle('is-saving', on);
      this._refreshAtcState();
    }

    _addToCart() {
      var self = this;
      if (this._saving) return;                       // double-tap guard
      if (!this._photoObj && !this._textObj) return;
      if (!this._rightsSatisfied()) {                 // gate, belt and braces
        this._refreshAtcState();
        if (this._rightsBox) this._rightsBox.focus();
        return;
      }

      var ts = Date.now();
      var designId = 'mw-' + ts + '-' + Math.random().toString(36).slice(2, 8);

      this._setBusy(true, 'Preparing your design…');
      this._setStatus('');

      this.exportDesign()
        .then(function (out) {
          self._setBusy(true, 'Uploading your design…');
          return self._originalForUpload()
            .then(function (original) {
              // Zipped, or Shopify re-encodes it on the way in and the archive
              // is worth nothing. See _zipOriginal.
              if (!original) return null;
              return self._zipOriginal(original.blob, original.name);
            })
            .then(function (originalZip) {
            var fd = new FormData(self._form);   // variant id + visible properties

            fd.append('properties[_print_file]', out.print, 'print_' + ts + '.jpg');
            fd.append('properties[_preview_file]', out.preview, 'preview_' + ts + '.jpg');
            if (originalZip) {
              fd.append('properties[_original_1]', originalZip, 'original_' + ts + '.zip');
            }
            fd.append('properties[_design_id]', designId);
            if (out.dpi !== null && out.dpi !== undefined) {
              fd.append('properties[_effective_dpi]', String(out.dpi));
            }
            if (out.previewAspect) {
              // Lets the cart reserve the right space before the image loads.
              fd.append('properties[_preview_ar]', out.previewAspect);
            }
            if (self._rightsConfirmedAt) {
              fd.append('properties[_rights_confirmed]', self._rightsConfirmedAt);
            }

            self._lastOriginalBytes = originalZip ? originalZip.size : 0;

            // No Content-Type header — the browser must set the multipart boundary.
            return fetch(self._cartAddUrl(), { method: 'POST', body: fd })
              .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); });
          });
        })
        .then(function (res) {
          if (!res.ok || (res.json.status && res.json.status !== 200)) {
            throw new Error(res.json.description || res.json.message || 'Add to cart failed');
          }
          log('added to cart', res.json.items ? res.json.items[0] : res.json);
          self._afterAdd(res.json);
        })
        .catch(function (err) {
          log('add to cart failed', err);
          self._setStatus('Sorry — we could not add your design. Please try again.');
        })
        .finally(function () {
          self._setBusy(false);
        });
    }

    /** The raw original is kept so a bad print can be rebuilt by hand. But a
     *  DSLR JPEG can be 20–40MB: slow to upload on mobile data and liable to
     *  hit Shopify's per-file limit, which would fail the whole add-to-cart.
     *  Above the cap we upload the decoded, EXIF-corrected, template-sized
     *  copy instead — still a genuine archival source, a fraction of the size. */
    _originalForUpload() {
      var file = this._originalFile;
      if (!file) return Promise.resolve(null);

      var ext = String(file.name || 'original.jpg').split('.').pop().toLowerCase();
      var name = file.name || ('original.' + (ext || 'jpg'));
      if (file.size <= MAX_ORIGINAL_BYTES) {
        return Promise.resolve({ blob: file, name: name });
      }

      var el = this._photoObj && this._photoObj.getElement && this._photoObj.getElement();
      if (!el || !el.width) {
        log('oversized original and no decoded copy available — uploading as is');
        return Promise.resolve({ blob: file, name: name });
      }
      log('original too large, uploading decoded copy', {
        originalMB: (file.size / 1048576).toFixed(1),
        decoded: el.width + 'x' + el.height
      });
      return new Promise(function (resolve) {
        var cv = document.createElement('canvas');
        cv.width = el.width;
        cv.height = el.height;
        var ctx = cv.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, cv.width, cv.height);
        ctx.drawImage(el, 0, 0);
        cv.toBlob(function (blob) {
          resolve(blob ? { blob: blob, name: 'decoded-copy.jpg' } : { blob: file, name: name });
        }, 'image/jpeg', 0.92);
      });
    }

    /** Wraps a file in an uncompressed ZIP so it reaches the order untouched.
     *
     *  Shopify's cart upload sniffs the bytes and re-encodes anything it reads
     *  as an image — a control JPEG sent baseline 4:4:4 DC=8 came back
     *  progressive 4:2:0 DC=5, and a HEIC comes back as a JPEG. Renaming does
     *  not help; the extension is ignored. A ZIP is not an image, so it is
     *  stored verbatim and the CDN serves it as application/zip instead of
     *  substituting a WEBP rendition.
     *
     *  Deliberately duplicated from the deskmat customizer rather than shared:
     *  the two files have no common module today, and per the house rule the
     *  extraction happens before a THIRD custom product, not during the second. */
    _zipOriginal(blob, entryName) {
      var self = this;
      return blob.arrayBuffer().then(function (buf) {
        var data = new Uint8Array(buf);
        var name = new TextEncoder().encode(entryName || 'original');

        if (!self._crcTable) {
          var t0 = new Int32Array(256);
          for (var i = 0; i < 256; i++) {
            var c0 = i;
            for (var k = 0; k < 8; k++) c0 = (c0 & 1) ? (0xEDB88320 ^ (c0 >>> 1)) : (c0 >>> 1);
            t0[i] = c0;
          }
          self._crcTable = t0;
        }
        var t = self._crcTable, c = -1;
        for (var j = 0; j < data.length; j++) c = t[(c ^ data[j]) & 255] ^ (c >>> 8);
        var crc = (c ^ -1) >>> 0;

        // DOS timestamp, so the extracted file keeps the customer's own mtime
        // instead of 1980 — it is evidence about when the photo was taken.
        var d = new Date(blob.lastModified || Date.now());
        var dosTime = (d.getHours() << 11) | (d.getMinutes() << 5) | (d.getSeconds() >> 1);
        var dosDate = ((d.getFullYear() - 1980) << 9) | ((d.getMonth() + 1) << 5) | d.getDate();
        var n = data.length;

        var lfh = new DataView(new ArrayBuffer(30));
        lfh.setUint32(0, 0x04034b50, true); lfh.setUint16(4, 20, true);
        lfh.setUint16(6, 0x0800, true);  // bit 11: the name is UTF-8
        lfh.setUint16(8, 0, true);       // method 0 = stored
        lfh.setUint16(10, dosTime, true); lfh.setUint16(12, dosDate, true);
        lfh.setUint32(14, crc, true); lfh.setUint32(18, n, true); lfh.setUint32(22, n, true);
        lfh.setUint16(26, name.length, true); lfh.setUint16(28, 0, true);

        var cdh = new DataView(new ArrayBuffer(46));
        cdh.setUint32(0, 0x02014b50, true); cdh.setUint16(4, 20, true); cdh.setUint16(6, 20, true);
        cdh.setUint16(8, 0x0800, true); cdh.setUint16(10, 0, true);
        cdh.setUint16(12, dosTime, true); cdh.setUint16(14, dosDate, true);
        cdh.setUint32(16, crc, true); cdh.setUint32(20, n, true); cdh.setUint32(24, n, true);
        cdh.setUint16(28, name.length, true); cdh.setUint32(42, 0, true);

        var eocd = new DataView(new ArrayBuffer(22));
        eocd.setUint32(0, 0x06054b50, true);
        eocd.setUint16(8, 1, true); eocd.setUint16(10, 1, true);
        eocd.setUint32(12, 46 + name.length, true);
        eocd.setUint32(16, 30 + name.length + n, true);

        return new Blob([lfh.buffer, name, data, cdh.buffer, name, eocd.buffer],
                        { type: 'application/zip' });
      });
    }

    _cartAddUrl() {
      var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      return base.indexOf('.js') === -1 ? base + '.js' : base;
    }

    /** Refresh + open the existing cart drawer using its own public API —
     *  never touch its DOM directly (it owns the live Shiprocket node). */
    _afterAdd(cartJson) {
      try {
        // pubsub.js declares `publish` as a function (so it IS on window) but
        // constants.js declares PUB_SUB_EVENTS with `const`, which creates a
        // global lexical binding that is NOT on window. Reference both as
        // bare globals under typeof guards, or the publish silently no-ops.
        var pub = (typeof publish === 'function') ? publish : null;
        var events = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : null;
        if (pub && events && events.cartUpdate) {
          pub(events.cartUpdate, {
            source: 'mw-customizer',
            productVariantId: this._form.querySelector('[name="id"]').value,
            cartData: cartJson
          });
        } else {
          log('pubsub unavailable — skipped cartUpdate');
        }
      } catch (err) {
        log('cartUpdate publish failed (non-fatal)', err);
      }

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(cartJson);   // V2: refresh + open, Shiprocket-safe
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    }

    /* ---------------- Gate 8: export + resolution guard ---------------- */

    /** Effective print resolution of the customer's photo.
     *  The photo spans (sourcePx x scale x printMultiplier) pixels of the
     *  print file; the print file is authored at print_dpi, so the real
     *  resolution is print_dpi scaled by how far the source is stretched. */
    _effectiveDpi() {
      var p = this._photoObj;
      if (!p || !this._art) return null;
      var dpi = (this.czConfig && this.czConfig.print_dpi) || 300;
      var spread = p.scaleX * this._printMultiplier();
      if (!isFinite(spread) || spread <= 0) return null;
      return Math.round(dpi / spread);
    }

    /**
     * Thresholds and wording come from the editor block, defaulting to 120/90.
     *
     * They used to be 150/100 in this file. 150 DPI is a print-shop floor for
     * work inspected close up, not for a phone case held at arm's length, so
     * the amber note fired on photos that print perfectly well — a customer who
     * nudged the zoom got told their image was too small, which reads as "your
     * photo is bad" and costs a sale. 120 leaves room for ordinary zooming and
     * still catches genuinely small sources; below 90 softness is visible.
     *
     * Settings rather than constants because the right number depends on what
     * the printer actually produces, and that is the owner's call to tune after
     * seeing real orders come back, not something to redeploy for.
     */
    _updateDpiWarning() {
      var el = this._dpiEl;
      if (!el) return;
      var dpi = this._effectiveDpi();
      this._lastDpi = dpi;
      el.classList.remove('is-amber', 'is-red');

      var softAt = parseInt(el.getAttribute('data-soft-below'), 10);
      var badAt = parseInt(el.getAttribute('data-bad-below'), 10);
      if (!isFinite(softAt) || softAt <= 0) softAt = 70;
      if (!isFinite(badAt) || badAt <= 0) badAt = 50;
      // A bad threshold at or above the soft one would make every warning red.
      if (badAt > softAt) badAt = softAt;

      if (dpi === null || dpi >= softAt) { el.hidden = true; return; }
      el.hidden = false;
      if (dpi < badAt) {
        el.classList.add('is-red');
        el.textContent = el.getAttribute('data-bad-msg')
          || 'This photo will print blurry at this size. Try a larger photo, or make it smaller on the case.';
      } else {
        el.classList.add('is-amber');
        el.textContent = el.getAttribute('data-soft-msg')
          || 'This photo may print soft at this size. A larger photo would look sharper.';
      }
    }

    /** Renders a canvas region at an exact output size, flattened onto white
     *  (JPEG has no alpha — without this, transparent pixels turn black). */
    _renderRegion(region, outW, outH, quality) {
      var el = this.czCanvas.toCanvasElement(outW / region.w, {
        left: region.x, top: region.y, width: region.w, height: region.h
      });
      var out = document.createElement('canvas');
      out.width = outW;
      out.height = outH;
      var ctx = out.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, outW, outH);
      ctx.drawImage(el, 0, 0, outW, outH);
      return new Promise(function (resolve, reject) {
        out.toBlob(function (blob) {
          if (blob) resolve(blob); else reject(new Error('toBlob returned null'));
        }, 'image/jpeg', quality);
      });
    }

    /** Builds the print file and the preview.
     *  PRINT  = artwork region only, at the exact print dimensions, with the
     *           case mockup hidden — artwork only, nothing else (NBE spec).
     *  PREVIEW= the same design WITH the case, as the customer approved it.
     *  The overlay hide/show is wrapped in try/finally: if the export throws
     *  mid-way the case must never be left invisible on screen. */
    exportDesign() {
      var self = this;
      var canvas = this.czCanvas;
      var art = this._art;
      if (!canvas || !art) return Promise.reject(new Error('canvas not ready'));

      var printW = this._templateW;
      var printH = this._templateH;
      var ov = canvas.overlayImage;

      // No selection chrome, no guides, no placeholder in either file.
      // excludeFromExport only affects JSON serialisation, NOT rendering —
      // anything left visible here is printed on the case.
      canvas.discardActiveObject();
      this._setGuidesVisible(false);
      this._hideOverflow();       // renders regardless of excludeFromExport
      var placeholderWas = this._placeholder && this._placeholder.visible;
      if (this._placeholder) this._placeholder.visible = false;
      this._stageEl.classList.remove('is-editing');

      // On screen the canvas is transparent and the artwork is clipped to the
      // case. Neither is right for the files: the print file is rectangular
      // artwork edge to edge (NBE spec), and both files are JPEG, where
      // transparency would come out black.
      var bgWas = canvas.backgroundColor;
      canvas.backgroundColor = '#ffffff';
      var clipped = [];
      canvas.getObjects().forEach(function (obj) {
        if (obj.clipPath && obj.clipPath.absolutePositioned) {
          clipped.push(obj);
          obj.clipPath = self._artClip();
        }
      });
      canvas.renderAll();

      var dpi = this._effectiveDpi();
      var result = {};

      return Promise.resolve()
        .then(function () {
          if (ov) ov.opacity = 0;          // step 2 — artwork only
          canvas.renderAll();
          return self._renderRegion(art, printW, printH, 0.94);
        })
        .then(function (blob) {
          result.print = blob;
        })
        .finally(function () {
          if (ov) ov.opacity = 1;          // step 4 — always restore
          if (self._placeholder) self._placeholder.visible = !!placeholderWas;
          // The preview is the case as the customer approved it, so the case
          // clip goes back on before that pass. The white background stays
          // until both files are rendered.
          clipped.forEach(function (obj) { obj.clipPath = self._caseClip(); });
          canvas.renderAll();
        })
        .then(function () {
          // Preview covers the whole case, so use the mockup's own bounds.
          var region = ov ? {
            x: ov.left, y: ov.top,
            w: ov.width * ov.scaleX, h: ov.height * ov.scaleY
          } : art;
          var outH = 1300;
          var outW = Math.round(region.w / region.h * outH);
          result.previewAspect = (outW / outH).toFixed(4);
          return self._renderRegion(region, outW, outH, 0.9);
        })
        .then(function (blob) {
          result.preview = blob;
          result.dpi = dpi;
          result.printDimensions = printW + 'x' + printH;
          log('export complete', {
            print: Math.round(result.print.size / 1024) + 'KB',
            preview: Math.round(result.preview.size / 1024) + 'KB',
            dims: result.printDimensions,
            dpi: dpi
          });
          return result;
        })
        .finally(function () {
          // Back to a transparent canvas so the page shows through around the
          // case. Runs on failure too — a white box must never be left behind.
          canvas.backgroundColor = bgWas;
          canvas.renderAll();
        });
    }

    /* ---------------- Gate 13: browse / edit mode ---------------- */

    /** THE mobile fix. Fabric stamps `touch-action: none` on the upper canvas
     *  unless allowTouchScrolling is true (it defaults to false), so a finger
     *  landing on the case froze the whole page — the case covers most of a
     *  phone screen, so the page was effectively unscrollable.
     *
     *  Browse mode: canvas ignores gestures, page scrolls normally.
     *  Edit mode:   canvas takes gestures, page scroll is locked on purpose. */
    _setMode(mode) {
      var canvas = this.czCanvas;
      if (!canvas || this._mode === mode) return;
      this._mode = mode;
      var editing = mode === 'edit';

      canvas.allowTouchScrolling = !editing;
      if (canvas.upperCanvasEl) {
        canvas.upperCanvasEl.style.touchAction = editing ? 'none' : 'manipulation';
      }
      canvas.selection = false;               // never multi-select
      canvas.skipTargetFind = !editing;       // browse: clicks pass through
      canvas.forEachObject(function (obj) {
        if (obj === canvas.overlayImage) return;
        obj.selectable = editing;
        obj.evented = editing;
      });

      if (!editing) {
        canvas.discardActiveObject();
        this._setGuidesVisible(false);
        this._hideOverflow();
        this._updateContextUI();
      }

      this.classList.toggle('is-edit-mode', editing);
      document.body.classList.toggle('mw-cz-editing', editing && this._isNarrow());
      this._stageEl.classList.toggle('is-editing', editing);
      if (this._editHintEl) this._editHintEl.hidden = editing;

      canvas.requestRenderAll();
      this._syncCanvasSize();
      log('mode →', mode);
    }

    _isNarrow() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    /** The mobile editor sheet changes the space available to the canvas, so
     *  re-measure whenever we switch modes. */
    _syncCanvasSize() {
      if (this._onResize) this._onResize();
    }

    enterEdit() {
      this._setMode('edit');
      var canvas = this.czCanvas;
      var target = this._photoObj || this._textObj;
      if (target) {
        canvas.setActiveObject(target);
        // Programmatic selection raises no selection:created, so the overflow
        // is raised here as well as from the event.
        this._showOverflow();
        canvas.requestRenderAll();
        this._updateContextUI();
      }
    }

    exitEdit() {
      this._setMode('browse');
    }

    /** Step strip reflects real editor state so the customer always knows
     *  where they are in a flow they have never seen before. */
    _updateSteps() {
      if (!this._stepEls) {
        this._stepEls = {};
        var self = this;
        Array.prototype.forEach.call(this.querySelectorAll('[data-mw-cz-step]'), function (el) {
          self._stepEls[el.getAttribute('data-mw-cz-step')] = el;
        });
      }
      var hasPhoto = !!this._photoObj;
      var hasText = !!this._textObj;
      var confirmed = this._rightsSatisfied();

      // Ordered checklist — the first unfinished step is the current one, so
      // exactly one is ever highlighted. Positioning counts as finished once
      // they've adjusted it or simply moved on (auto cover-fit is valid).
      var order = [
        { key: 'upload', done: hasPhoto },
        { key: 'position', done: hasPhoto && (this._touchedDesign || hasText || confirmed) },
        { key: 'text', done: hasText },
        { key: 'review', done: (hasPhoto || hasText) && confirmed }
      ];
      var currentFound = false;
      order.forEach(function (step) {
        var el = this._stepEls[step.key];
        if (!el) return;
        var isCurrent = !step.done && !currentFound;
        if (isCurrent) currentFound = true;
        el.classList.toggle('is-done', step.done);
        el.classList.toggle('is-current', isCurrent);
      }, this);
    }

    /* ---------- empty-case placeholder ----------
     *  Drawn INTO the canvas at the very back and sized to the printable
     *  area, so the mockup's bezel and camera render on top of it and it
     *  reads as part of the case rather than a box floating over it.
     *
     *  Canvas objects DO render into exports regardless of
     *  excludeFromExport (the Gate 8 trap), so this is added to the same
     *  explicit hide-list as the guides in exportDesign(). */
    _createPlaceholder() {
      var canvas = this.czCanvas;
      var art = this._art;
      var g = this._guideGeom;
      if (!canvas || !art || !g || this._placeholder) return;

      var x = art.x + g.sil.x0 * art.w;
      var y = art.y + g.sil.y0 * art.h;
      var w = (g.sil.x1 - g.sil.x0) * art.w;
      var h = (g.sil.y1 - g.sil.y0) * art.h;

      var plate = new window.fabric.Rect({
        left: x, top: y, width: w, height: h,
        rx: g.radius * art.w, ry: g.radius * art.w,
        fill: '#f4f5f7',
        originX: 'left', originY: 'top'
      });

      // Sits below the camera so it never fights the hardware graphic.
      var label = new window.fabric.Text('Your photo\nappears here', {
        left: x + w / 2, top: y + h * 0.58,
        originX: 'center', originY: 'center',
        fontFamily: 'MW Catamaran, sans-serif',
        fontSize: Math.max(11, Math.round(w * 0.075)),
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: 1.25,
        fill: '#9aa1aa'
      });

      var group = new window.fabric.Group([plate, label], {
        selectable: false, evented: false, excludeFromExport: true
      });
      this._placeholder = group;
      canvas.add(group);
      canvas.sendObjectToBack(group);
      canvas.requestRenderAll();
    }

    _syncPlaceholder() {
      if (!this._placeholder) return;
      var show = !this._photoObj;
      if (this._placeholder.visible !== show) {
        this._placeholder.visible = show;
        this.czCanvas.requestRenderAll();
      }
    }

    _rebuildPlaceholder() {
      if (this._placeholder && this.czCanvas) {
        this.czCanvas.remove(this._placeholder);
        this._placeholder = null;
      }
      this._createPlaceholder();
      this._syncPlaceholder();
    }

    /* ---------- keyboard-aware text editing (Gate 14) ---------- */

    /** The core mobile fix. With the keyboard up, the sheet used to fill the
     *  screen and the case disappeared — customers typed blind. visualViewport
     *  reports the space the keyboard actually leaves, which is the only
     *  reliable measure on iOS Safari and Android Chrome. The stage docks into
     *  whatever room is left so the case is visible the whole time.
     *  If the API is missing we fall back to a fixed split — never break. */
    _bindKeyboardDock() {
      var self = this;
      var vv = window.visualViewport;
      if (!vv) return;

      this._onViewportResize = function () {
        if (!self._isNarrow() || !self._modal || self._modal.hidden) return;
        // Space above the sheet = viewport height minus what the sheet needs.
        var sheet = self._modal.querySelector('.mw-cz-modal__panel');
        var sheetH = sheet ? sheet.getBoundingClientRect().height : 0;
        var room = Math.max(120, vv.height - sheetH - 16);
        self.style.setProperty('--cz-dock-h', Math.round(room) + 'px');
        self.style.setProperty('--cz-dock-top', Math.round(vv.offsetTop + 8) + 'px');
        self._syncCanvasSize();
      };

      vv.addEventListener('resize', this._onViewportResize);
      vv.addEventListener('scroll', this._onViewportResize);
    }

    _dockStageForTyping(on) {
      if (!this._isNarrow()) return;
      this.classList.toggle('is-docked', on);
      document.body.classList.toggle('mw-cz-typing', on);
      if (on && this._onViewportResize) {
        // Let the sheet lay out first, then measure the real space.
        var self = this;
        setTimeout(function () { self._onViewportResize(); }, 60);
      } else {
        this.style.removeProperty('--cz-dock-h');
        this.style.removeProperty('--cz-dock-top');
      }
      this._syncCanvasSize();
    }

    _bindModeControls() {
      var self = this;
      this._editHintEl = this.querySelector('[data-mw-cz-edit-hint]');
      this._editOpenBtn = this.querySelector('[data-mw-cz-edit-open]');

      // Tapping the case starts editing (browse mode swallows canvas events).
      this._stageEl.addEventListener('click', function () {
        if (self._mode !== 'edit' && (self._photoObj || self._textObj)) self.enterEdit();
      });

      var on = function (sel, fn) {
        var el = self.querySelector(sel);
        if (el) el.addEventListener('click', fn);
      };
      on('[data-mw-cz-edit-open]', function () { self.enterEdit(); });
      on('[data-mw-cz-edit-done]', function () { self.exitEdit(); });
      on('[data-mw-cz-edit-cancel]', function () { self.exitEdit(); });

      this._onEditKey = function (e) {
        if (e.key === 'Escape' && self._mode === 'edit' && self._modal && self._modal.hidden) {
          self.exitEdit();
        }
      };
      document.addEventListener('keydown', this._onEditKey);
    }

    /* ---------------- Gate 7: selection UI + touch ---------------- */

    _bindContextControls() {
      var self = this;
      this._contextEl = this.querySelector('[data-mw-cz-context]');
      this._contextLabel = this.querySelector('[data-mw-cz-context-label]');
      this._ctlEdit = this.querySelector('[data-mw-cz-ctl-edit]');
      if (!this._contextEl) return;

      var on = function (sel, fn) {
        var el = self.querySelector(sel);
        if (el) el.addEventListener('click', fn);
      };

      on('[data-mw-cz-ctl-edit]', function () { self._openTextModal(); });

      on('[data-mw-cz-ctl-centre]', function () {
        var obj = self.czCanvas.getActiveObject();
        if (!obj) return;
        var art = self._art;
        obj.setPositionByOrigin(
          new window.fabric.Point(art.x + art.w / 2, art.y + art.h / 2),
          'center', 'center'
        );
        obj.setCoords();
        self.czCanvas.requestRenderAll();
      });

      on('[data-mw-cz-ctl-straighten]', function () {
        var obj = self.czCanvas.getActiveObject();
        if (!obj) return;
        var centre = obj.getCenterPoint();
        obj.angle = 0;
        obj.setPositionByOrigin(centre, 'center', 'center');
        obj.setCoords();
        self.czCanvas.requestRenderAll();
      });

      on('[data-mw-cz-ctl-delete]', function () {
        var obj = self.czCanvas.getActiveObject();
        if (!obj) return;
        if (obj === self._textObj) {
          self._removeTextObject();
        } else if (obj === self._photoObj) {
          self.czCanvas.remove(obj);
          self._photoObj = null;
          self._originalFile = null;
          self._photoBtn.textContent = 'Add Photo';
          if (self._hintEl) self._hintEl.hidden = true;
          self._updateDpiWarning();
          self._refreshAtcState();
        } else {
          self.czCanvas.remove(obj);
        }
        self.czCanvas.discardActiveObject();
        self.czCanvas.requestRenderAll();
        self._setGuidesVisible(false);
        self._stageEl.classList.remove('is-editing');
        self._updateContextUI();
      });
    }

    /** Contextual toolbar: hidden when nothing is selected; the Edit button
     *  exists for text only (spec §A8 — never for images). */
    _updateContextUI() {
      if (!this._contextEl) return;
      var obj = this.czCanvas ? this.czCanvas.getActiveObject() : null;
      var isText = !!obj && obj === this._textObj;
      var wasHidden = this._contextEl.hidden;
      this._contextEl.hidden = !obj;
      if (obj) {
        this._contextLabel.textContent = isText ? 'Text selected' : 'Photo selected';
        this._ctlEdit.hidden = !isText;
      }
      // The panel changes the room available to the case in the mobile sheet.
      if (wasHidden !== this._contextEl.hidden && this._mode === 'edit' && this._isNarrow()) {
        this._syncCanvasSize();
      }
    }

    /** Two-finger pinch-to-zoom and twist-to-rotate. Fabric v6 has no
     *  multi-touch gestures, so this handles them directly on the canvas.
     *  Capture phase + preventDefault stops Fabric treating the second
     *  finger as a drag and stops the page pinch-zooming underneath. */
    _bindTouchGestures() {
      var self = this;
      var canvas = this.czCanvas;
      var el = canvas.upperCanvasEl;
      if (!el || !window.matchMedia) return;
      var start = null;

      var spread = function (t) {
        var dx = t[0].clientX - t[1].clientX;
        var dy = t[0].clientY - t[1].clientY;
        return { dist: Math.sqrt(dx * dx + dy * dy), angle: Math.atan2(dy, dx) * 180 / Math.PI };
      };

      var onStart = function (e) {
        if (e.touches.length !== 2) return;
        var obj = canvas.getActiveObject();
        if (!obj) return;
        var s = spread(e.touches);
        start = {
          dist: s.dist, angle: s.angle,
          scaleX: obj.scaleX, ratio: obj.scaleY / obj.scaleX, objAngle: obj.angle
        };
        // Fabric began a one-finger drag on the first touch and has no idea a
        // second finger landed. Left running, it keeps applying its own drag
        // delta while this handler applies the pinch — two transforms on one
        // object, which is the jump when the second finger touches down.
        // Cancelling its in-flight transform leaves the pinch in sole control;
        // the selection itself is untouched.
        canvas._currentTransform = null;
        e.preventDefault();
        e.stopPropagation();
      };

      var onMove = function (e) {
        if (!start || e.touches.length !== 2) return;
        var obj = canvas.getActiveObject();
        if (!obj) { start = null; return; }
        e.preventDefault();
        e.stopPropagation();

        canvas._currentTransform = null;   // keep Fabric out for the whole gesture

        var s = spread(e.touches);
        var isPhoto = obj === self._photoObj;
        var lim = isPhoto ? self._photoScaleBounds(obj) : { min: 0.05, max: 20 };
        var min = lim.min, max = lim.max;
        var next = Math.min(max, Math.max(min, start.scaleX * (s.dist / start.dist)));

        // Scale about the point between the fingers, not the object's centre,
        // so the image grows from where the pinch is instead of sliding.
        var rect = el.getBoundingClientRect();
        var mid = new window.fabric.Point(
          (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left,
          (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top
        );
        var before = obj.getCenterPoint();

        // Twist under about 8 degrees is finger wobble, not an intent to
        // rotate; without the dead zone the image nudged round on every pinch.
        var twist = s.angle - start.angle;
        if (Math.abs(twist) < 8) twist = 0;
        var turned = start.objAngle + twist;

        var k = next / obj.scaleX;
        obj.scaleX = next;
        obj.scaleY = next * start.ratio;
        obj.angle = ((turned % 360) + 360) % 360;   // keep it 0–360, not -348
        obj.setPositionByOrigin(
          new window.fabric.Point(
            mid.x + (before.x - mid.x) * k,
            mid.y + (before.y - mid.y) * k
          ), 'center', 'center'
        );
        obj.setCoords();
        if (isPhoto) self._syncOverflow();
        canvas.requestRenderAll();
      };

      var onEnd = function (e) {
        if (e.touches.length < 2) start = null;
      };

      var opts = { passive: false, capture: true };
      el.addEventListener('touchstart', onStart, opts);
      el.addEventListener('touchmove', onMove, opts);
      el.addEventListener('touchend', onEnd, opts);
      el.addEventListener('touchcancel', onEnd, opts);
      this._touchTeardown = function () {
        el.removeEventListener('touchstart', onStart, opts);
        el.removeEventListener('touchmove', onMove, opts);
        el.removeEventListener('touchend', onEnd, opts);
        el.removeEventListener('touchcancel', onEnd, opts);
      };
    }

    /* ---------------- Gate 6: one text layer ---------------- */

    _bindTextUI() {
      var self = this;
      this._textBtn = this.querySelector('[data-mw-cz-tool="text"]');
      this._modal = this.querySelector('[data-mw-cz-modal]');
      if (!this._textBtn || !this._modal) return;

      this._textInput = this._modal.querySelector('[data-mw-cz-text-input]');
      this._textCount = this._modal.querySelector('[data-mw-cz-text-count]');
      this._fontsWrap = this._modal.querySelector('[data-mw-cz-fonts]');
      this._coloursWrap = this._modal.querySelector('[data-mw-cz-colours]');
      this._stylesWrap = this._modal.querySelector('[data-mw-cz-styles]');
      // Two of each: the footer pair (desktop) and the head pair (mobile).
      // Only one pair is ever visible, but both are bound and kept in sync.
      this._removeBtns = this._modal.querySelectorAll('[data-mw-cz-text-remove]');

      this._fontCatWrap = this._modal.querySelector('[data-mw-cz-font-cats]');
      this._draft = { font: DEFAULT_FONT, colour: COLOURS[0], style: STYLES[0], adjust: defaultAdjust() };

      this._buildFontChips();
      this._buildFontCategories();
      this._buildColourChips();
      this._buildStyleChips();
      this._bindAdjustControls();
      this._selectFontCategory(DEFAULT_FONT.cat);

      this._textBtn.disabled = false;
      this._textBtn.addEventListener('click', function () { self._openTextModal(); });

      Array.prototype.forEach.call(
        this._modal.querySelectorAll('[data-mw-cz-modal-close]'),
        function (el) { el.addEventListener('click', function () { self._closeTextModal(); }); }
      );
      this._onModalKey = function (e) {
        if (e.key === 'Escape' && !self._modal.hidden) self._closeTextModal();
      };
      document.addEventListener('keydown', this._onModalKey);

      this._fontNote = this._modal.querySelector('[data-mw-cz-font-note]');
      this._bindOptionTabs();

      this._textInput.addEventListener('input', function () {
        self._liveUpdate();
        self._syncFontPreviews();   // chips preview the customer's own text
      });

      Array.prototype.forEach.call(
        this._modal.querySelectorAll('[data-mw-cz-text-apply]'),
        function (el) { el.addEventListener('click', function () { self._commitText(); }); }
      );
      Array.prototype.forEach.call(this._removeBtns, function (el) {
        el.addEventListener('click', function () { self._removeText(); });
      });
    }

    /** Enforces the 40-letter / 3-line limit. Letters are counted as
     *  graphemes so Tamil gets the same allowance as English and a letter
     *  is never cut in half. */
    _clampTextInput() {
      var v = this._textInput.value.replace(/\r/g, '');
      var lines = v.split('\n');
      if (lines.length > TEXT_MAX_LINES) {
        lines = lines.slice(0, TEXT_MAX_LINES);
        v = lines.join('\n');
      }
      if (countGraphemes(v) > TEXT_MAX_CHARS) v = sliceGraphemes(v, TEXT_MAX_CHARS);
      if (v !== this._textInput.value) this._textInput.value = v;
      return v;
    }

    /** A font without Tamil glyphs silently falls back to whatever font the
     *  customer's device has — and because the print file is rasterised on
     *  that device, the case would print in a typeface nobody chose. So when
     *  the text contains Tamil, non-Tamil fonts are locked out. */
    _syncFontAvailability() {
      var self = this;
      var hasTamil = TAMIL_RE.test(this._textInput.value);
      var switched = false;

      Array.prototype.forEach.call(this._fontsWrap.children, function (chip, i) {
        var font = FONTS[i];
        var blocked = hasTamil && !font.tamil;
        chip.disabled = blocked;
        chip.classList.toggle('is-unavailable', blocked);
        chip.title = blocked ? 'This font has no Tamil letters' : '';
      });

      if (hasTamil && this._draft.font && !this._draft.font.tamil) {
        for (var i = 0; i < FONTS.length; i++) {
          if (FONTS[i].tamil) {
            this._draft.font = FONTS[i];
            this._markChosen(this._fontsWrap, this._fontsWrap.children[i]);
            this._loadFont(FONTS[i]);
            // Show the category the customer was just moved into, or the chips
            // on screen would not include the font now selected.
            this._selectFontCategory(FONTS[i].cat);
            switched = true;
            break;
          }
        }
      }

      if (this._fontNote) {
        var noteWas = this._fontNote.hidden;
        this._fontNote.hidden = !hasTamil;
        this._fontNote.textContent = switched
          ? 'Switched to a Tamil font — the other fonts have no Tamil letters.'
          : 'Only Tamil-capable fonts are shown for Tamil text.';
        // The note changes the sheet height, so the case has to be re-docked —
        // but only when it appears or disappears, never on every keystroke.
        if (noteWas !== this._fontNote.hidden && this._onViewportResize) {
          this._onViewportResize();
        }
      }
      return hasTamil;
    }

    /** Every chip is built once, in FONTS order, so the index-based syncing in
     *  _syncChips and _syncFontAvailability keeps working. Categories filter by
     *  hiding chips rather than rebuilding — which is also what makes the fonts
     *  lazy: a hidden chip renders nothing, so its font is never fetched. */
    _buildFontChips() {
      var self = this;
      this._fontsWrap.innerHTML = '';
      FONTS.forEach(function (font, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mw-cz-chip mw-cz-chip--font';
        b.setAttribute('role', 'radio');
        b.setAttribute('data-mw-cz-font-cat', font.cat);
        b.style.fontFamily = "'" + font.css + "', sans-serif";
        b.style.fontWeight = font.weight;

        var label = document.createElement('span');
        label.className = 'mw-cz-chip__preview';
        label.textContent = font.label;
        b.appendChild(label);
        b._mwPreview = label;

        if (font.tamil) {
          var tag = document.createElement('span');
          tag.className = 'mw-cz-chip__tag';
          tag.textContent = 'தமிழ்';
          b.appendChild(tag);
        }
        b.addEventListener('click', function () {
          self._draft.font = font;
          self._markChosen(self._fontsWrap, b);
          self._clampTextScale();
          self._loadFont(font).then(function () { self._liveUpdate(); });
          self._liveUpdate();
        });
        var chosen = font === DEFAULT_FONT;
        b.setAttribute('aria-checked', chosen ? 'true' : 'false');
        if (chosen) b.classList.add('is-chosen');
        self._fontsWrap.appendChild(b);
      });
    }

    /** Size / spacing / rotation / alignment. Each control writes into
     *  _draft.adjust and re-renders the one text object — no editor rebuild,
     *  which is what keeps dragging smooth while these are open. */
    _bindAdjustControls() {
      var self = this;
      this._adjNote = this._modal.querySelector('[data-mw-cz-adj-note]');
      this._adjInputs = {};

      Array.prototype.forEach.call(
        this._modal.querySelectorAll('[data-mw-cz-adj]'),
        function (el) {
          var key = el.getAttribute('data-mw-cz-adj');
          self._adjInputs[key] = el;
          el.addEventListener('input', function () {
            var v = parseFloat(el.value);
            self._draft.adjust[key] = key === 'scale' ? v / 100 : v;
            if (key === 'scale') self._clampTextScale();
            self._liveUpdate();
          });
        }
      );

      Array.prototype.forEach.call(
        this._modal.querySelectorAll('[data-mw-cz-align-btn]'),
        function (btn) {
          btn.addEventListener('click', function () {
            self._draft.adjust.align = btn.getAttribute('data-mw-cz-align-btn');
            self._syncAdjustUI();
            self._liveUpdate();
          });
        }
      );

      var reset = this._modal.querySelector('[data-mw-cz-adj-reset]');
      if (reset) {
        reset.addEventListener('click', function () {
          self._draft.adjust = defaultAdjust();
          self._syncAdjustUI();
          self._liveUpdate();
        });
      }
    }

    /** Print safety: thin signature faces break up on glass below a larger
     *  size than solid ones, so the floor depends on the chosen font. This
     *  raises the size rather than letting an unprintable one through. */
    _clampTextScale() {
      var adj = this._draft.adjust;
      var font = this._draft.font || DEFAULT_FONT;
      var min = font.thin ? MIN_TEXT_SCALE_THIN : MIN_TEXT_SCALE;
      var raised = adj.scale < min;
      adj.scale = Math.min(MAX_TEXT_SCALE, Math.max(min, adj.scale));
      if (this._adjNote) {
        var was = this._adjNote.hidden;
        this._adjNote.hidden = !raised;
        this._adjNote.textContent =
          'Made a little larger — ' + font.label + ' is a fine typeface and ' +
          'prints poorly below this size.';
        if (was !== this._adjNote.hidden && this._onViewportResize) this._onViewportResize();
      }
      this._syncAdjustUI();
    }

    _syncAdjustUI() {
      var adj = this._draft.adjust;
      if (!this._adjInputs) return;
      if (this._adjInputs.scale) this._adjInputs.scale.value = String(Math.round(adj.scale * 100));
      if (this._adjInputs.spacing) this._adjInputs.spacing.value = String(adj.spacing);
      if (this._adjInputs.angle) this._adjInputs.angle.value = String(adj.angle);
      Array.prototype.forEach.call(
        this._modal.querySelectorAll('[data-mw-cz-align-btn]'),
        function (b) {
          var on = b.getAttribute('data-mw-cz-align-btn') === adj.align;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      );
    }

    _buildFontCategories() {
      var self = this;
      if (!this._fontCatWrap) return;
      this._fontCatWrap.innerHTML = '';
      FONT_CATEGORIES.forEach(function (cat) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mw-cz-fontcat';
        b.setAttribute('data-mw-cz-font-cat-btn', cat.id);
        b.textContent = cat.label;
        b.addEventListener('click', function () { self._selectFontCategory(cat.id); });
        self._fontCatWrap.appendChild(b);
      });
    }

    /** Showing a category is what triggers its font downloads, so this is the
     *  lazy-load boundary. Previews are refreshed here because chips that were
     *  hidden never picked up the customer's latest text. */
    _selectFontCategory(id) {
      if (!this._fontCatWrap) return;
      this._fontCat = id;
      Array.prototype.forEach.call(this._fontCatWrap.children, function (b) {
        var on = b.getAttribute('data-mw-cz-font-cat-btn') === id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(this._fontsWrap.children, function (chip) {
        chip.hidden = chip.getAttribute('data-mw-cz-font-cat') !== id;
      });
      this._syncFontPreviews();
      if (this._onViewportResize) this._onViewportResize();
    }

    /** The chips preview the customer's actual name rather than font names —
     *  the whole point of the picker is seeing YOUR text in each style. */
    _syncFontPreviews() {
      if (!this._fontsWrap || !this._textInput) return;
      var raw = (this._textInput.value || '').split('\n')[0].trim();
      var text = raw.slice(0, CHIP_PREVIEW_CHARS);
      Array.prototype.forEach.call(this._fontsWrap.children, function (chip, i) {
        if (chip.hidden || !chip._mwPreview) return;
        chip._mwPreview.textContent = text || FONTS[i].label;
      });
    }

    _buildColourChips() {
      var self = this;
      this._coloursWrap.innerHTML = '';
      COLOURS.forEach(function (colour, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mw-cz-swatch';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-label', colour);
        b.style.background = colour;
        b.addEventListener('click', function () {
          self._draft.colour = colour;
          self._markChosen(self._coloursWrap, b);
          self._liveUpdate();
        });
        b.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
        if (i === 0) b.classList.add('is-chosen');
        self._coloursWrap.appendChild(b);
      });
    }

    _buildStyleChips() {
      var self = this;
      this._stylesWrap.innerHTML = '';
      STYLES.forEach(function (style, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mw-cz-chip';
        b.setAttribute('role', 'radio');
        b.textContent = style.label;
        b.addEventListener('click', function () {
          self._draft.style = style;
          self._markChosen(self._stylesWrap, b);
          self._liveUpdate();
        });
        b.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
        if (i === 0) b.classList.add('is-chosen');
        self._stylesWrap.appendChild(b);
      });
    }

    _markChosen(wrap, el) {
      Array.prototype.forEach.call(wrap.children, function (c) {
        c.classList.toggle('is-chosen', c === el);
        c.setAttribute('aria-checked', c === el ? 'true' : 'false');
      });
    }

    /** Canvas needs the font actually loaded before it can rasterise it. */
    _loadFont(font) {
      if (!font || !document.fonts || !document.fonts.load) return Promise.resolve();
      var spec = font.weight + ' 48px "' + font.css + '"';
      return document.fonts.load(spec, 'Aa அஆஇ').catch(function (err) {
        log('font load failed', font.css, err);
      });
    }

    /** Mobile only: Font / Colour / Style are stacked on desktop but shown one
     *  at a time on a phone, where the full stack pushed the case off screen.
     *  The buttons are display:none above 749px, so this is inert on desktop. */
    _bindOptionTabs() {
      var self = this;
      this._optionTabs = this._modal.querySelectorAll('[data-mw-cz-tab]');
      this._optionGroups = this._modal.querySelectorAll('[data-mw-cz-group]');
      Array.prototype.forEach.call(this._optionTabs, function (tab) {
        tab.addEventListener('click', function () {
          self._selectOptionTab(tab.getAttribute('data-mw-cz-tab'));
        });
      });
    }

    _selectOptionTab(name) {
      if (!this._optionTabs) return;
      Array.prototype.forEach.call(this._optionTabs, function (tab) {
        var on = tab.getAttribute('data-mw-cz-tab') === name;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(this._optionGroups, function (group) {
        group.classList.toggle('is-active', group.getAttribute('data-mw-cz-group') === name);
      });
      // Groups differ slightly in height; re-dock so the case keeps the rest.
      if (this._onViewportResize) this._onViewportResize();
    }

    _openTextModal() {
      var self = this;
      var existing = this._textObj;
      if (existing) {
        this._textInput.value = existing.text || '';
        this._draft = {
          font: this._fontByCss(existing.fontFamily) || DEFAULT_FONT,
          colour: existing._mwColour || COLOURS[0],
          style: this._styleById(existing._mwStyleId) || STYLES[0],
          // Read back from the object, so dragging a corner on the case and the
          // Adjust slider agree with each other.
          adjust: existing._mwAdjust
            ? Object.assign(defaultAdjust(), existing._mwAdjust, { scale: existing.scaleX })
            : Object.assign(defaultAdjust(), { scale: existing.scaleX, angle: existing.angle })
        };
      } else {
        this._textInput.value = '';
        this._draft = { font: DEFAULT_FONT, colour: COLOURS[0], style: STYLES[0], adjust: defaultAdjust() };
      }
      this._syncChips();
      this._selectOptionTab('font');
      this._selectFontCategory((this._draft.font || DEFAULT_FONT).cat);
      this._syncAdjustUI();
      this._textCount.textContent = String(countGraphemes(this._textInput.value));
      this._syncFontAvailability();
      this._syncFontPreviews();
      Array.prototype.forEach.call(this._removeBtns, function (el) { el.hidden = !existing; });
      this._textSnapshot = this._snapshotText();
      this._modal.hidden = false;
      document.body.classList.add('mw-cz-modal-open');
      this._dockStageForTyping(true);   // keep the case visible while typing
      // Preload the chosen font while the customer types.
      this._loadFont(this._draft.font);
      setTimeout(function () { self._textInput.focus(); }, 30);
    }

    /** commit=false (✕ / Escape / backdrop) undoes the live edits. */
    _closeTextModal(commit) {
      if (!commit) this._restoreText(this._textSnapshot);
      this._textSnapshot = null;
      this._modal.hidden = true;
      document.body.classList.remove('mw-cz-modal-open');
      this._dockStageForTyping(false);
    }

    _syncChips() {
      var self = this;
      var mark = function (el, on) {
        el.classList.toggle('is-chosen', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      };
      Array.prototype.forEach.call(this._fontsWrap.children, function (c, i) {
        mark(c, FONTS[i] === self._draft.font);
      });
      Array.prototype.forEach.call(this._coloursWrap.children, function (c, i) {
        mark(c, COLOURS[i] === self._draft.colour);
      });
      Array.prototype.forEach.call(this._stylesWrap.children, function (c, i) {
        mark(c, STYLES[i] === self._draft.style);
      });
    }

    _fontByCss(css) {
      for (var i = 0; i < FONTS.length; i++) if (FONTS[i].css === css) return FONTS[i];
      return null;
    }

    _styleById(id) {
      for (var i = 0; i < STYLES.length; i++) if (STYLES[i].id === id) return STYLES[i];
      return null;
    }

    /** Live preview: every keystroke and option change renders on the case
     *  immediately. The font may still be downloading on first use, so we
     *  draw straight away and redraw once it resolves. */
    _liveUpdate() {
      var self = this;
      var value = this._clampTextInput();
      this._textCount.textContent = String(countGraphemes(value));
      this._syncFontAvailability();

      var trimmed = value.trim();
      if (!trimmed) {
        if (this._textObj) {
          this._textObj.visible = false;
          this.czCanvas.requestRenderAll();
        }
        return;
      }

      this._renderText(trimmed, false);
      var font = this._draft.font || DEFAULT_FONT;
      if (!document.fonts || !document.fonts.check ||
          !document.fonts.check(font.weight + ' 48px "' + font.css + '"', trimmed)) {
        this._loadFont(font).then(function () {
          if (self._destroyed || self._modal.hidden) return;
          var latest = self._textInput.value.trim();
          if (latest) self._renderText(latest, false);
        });
      }
    }

    /** Update = keep what's on the case and close. */
    _commitText() {
      var value = this._clampTextInput().trim();
      if (!value) return this._removeText();
      this.enterEdit();               // so it can be dragged straight away
      this._renderText(value, true);
      this._closeTextModal(true);
    }

    /** Snapshot so ✕ / Escape / backdrop can undo the live edits. */
    _snapshotText() {
      var t = this._textObj;
      if (!t) return { existed: false };
      return {
        existed: true, visible: t.visible, text: t.text,
        fontFamily: t.fontFamily, fontWeight: t.fontWeight, fontSize: t.fontSize,
        fill: t.fill, stroke: t.stroke, strokeWidth: t.strokeWidth,
        charSpacing: t.charSpacing, shadow: t.shadow,
        left: t.left, top: t.top, scaleX: t.scaleX, scaleY: t.scaleY, angle: t.angle,
        colour: t._mwColour, styleId: t._mwStyleId
      };
    }

    _restoreText(snap) {
      var canvas = this.czCanvas;
      if (!snap || !snap.existed) {
        if (this._textObj) {
          canvas.remove(this._textObj);
          this._textObj = null;
          this._textBtn.textContent = 'Add Text';
        }
      } else if (this._textObj) {
        this._textObj.set({
          visible: snap.visible, text: snap.text,
          fontFamily: snap.fontFamily, fontWeight: snap.fontWeight, fontSize: snap.fontSize,
          fill: snap.fill, stroke: snap.stroke, strokeWidth: snap.strokeWidth,
          charSpacing: snap.charSpacing, shadow: snap.shadow,
          left: snap.left, top: snap.top, scaleX: snap.scaleX, scaleY: snap.scaleY, angle: snap.angle
        });
        this._textObj._mwColour = snap.colour;
        this._textObj._mwStyleId = snap.styleId;
        this._textObj.setCoords();
      }
      canvas.requestRenderAll();
    }

    /** V1: ONE text layer — created once, then updated in place.
     *  `select` is false during live typing so focus stays in the textarea. */
    _renderText(value, select) {
      var canvas = this.czCanvas;
      var art = this._art;
      var font = this._draft.font || DEFAULT_FONT;
      var style = this._draft.style || STYLES[0];
      var obj = this._textObj;

      // Size relative to the artwork so it scales with the canvas.
      var fontSize = obj ? obj.fontSize : Math.round(art.w * 0.11);

      var adj = this._draft.adjust || (this._draft.adjust = defaultAdjust());
      var props = {
        text: value,
        fontFamily: font.css,
        fontWeight: font.weight,
        fill: this._draft.colour,
        textAlign: adj.align,
        stroke: style.stroke || null,
        strokeWidth: style.strokeWidth ? style.strokeWidth * fontSize : 0,
        paintFirst: 'stroke',
        // Adjust owns spacing; the style's value is the starting point so the
        // Wide/Tight presets still mean something once it has been touched.
        charSpacing: (style.charSpacing || 0) + adj.spacing,
        shadow: style.shadow || null,
        strokeUniform: true,
        angle: adj.angle
      };

      if (!obj) {
        // fabric.Text (not IText): no in-canvas typing, modal only.
        obj = new window.fabric.Text(value, Object.assign({
          originX: 'center',
          originY: 'center',
          left: art.x + art.w / 2,
          top: art.y + art.h * 0.78,
          fontSize: fontSize
        }, props));
        this._applyControlStyle(obj);
        obj.clipPath = this._caseClip();
        canvas.add(obj);
        this._textObj = obj;
      } else {
        obj.set(props);
        obj.visible = true;
      }
      // Size is a multiplier on the base so dragging a corner and using the
      // Adjust slider stay the same measurement.
      obj.set({ scaleX: adj.scale, scaleY: adj.scale });
      obj._mwColour = this._draft.colour;
      obj._mwStyleId = style.id;
      obj._mwAdjust = Object.assign({}, adj);
      obj._mwIsText = true;

      canvas.bringObjectToFront(obj);   // text always above the photo
      this._bringGuidesToFront();
      obj.setCoords();
      if (select) canvas.setActiveObject(obj);
      canvas.requestRenderAll();

      this._textBtn.textContent = 'Edit Text';
      if (this._zoomWrap) this._zoomWrap.hidden = false;
      this._refreshAtcState();
      log('text applied', { chars: value.length, font: font.css, style: style.id });
    }

    _removeTextObject() {
      if (this._textObj) {
        this.czCanvas.remove(this._textObj);
        this._textObj = null;
        this.czCanvas.requestRenderAll();
      }
      this._textBtn.textContent = 'Add Text';
      this._refreshAtcState();
    }

    _removeText() {
      this._removeTextObject();
      this._closeTextModal(true);
    }

    _onPhotoPicked(input) {
      var file = input.files && input.files[0];
      input.value = ''; // allow re-picking the same file
      if (!file) return;

      var problem = this._validatePhotoFile(file);
      if (problem) return this._setStatus(problem);

      var self = this;
      // What the customer actually chose, before _maybeConvertHeic replaces it.
      // This is what _original_1 must carry — a JPEG we made from their HEIC is
      // not their file, and is the very thing the archive exists to protect.
      var picked = file;
      this._setStatus('Adding your photo…');
      // HEIC first: browsers that cannot read it get the file converted here,
      // so _decodePhoto and the print upload both see bytes they understand.
      this._maybeConvertHeic(file)
        .then(function (usable) {
          file = usable;
          return self._decodePhoto(file);
        })
        .then(function (canvasEl) {
          if (self._destroyed) return;
          self._originalFile = picked; // kept for the _original_1 upload at Gate 9
          self.enterEdit();          // picking a photo means they want to position it
          self._placePhoto(canvasEl);
          self._setStatus('');
        })
        .catch(function (err) {
          log('photo decode failed', err);
          self._setStatus('Could not read that photo. Please try a different JPG or PNG.');
        });
    }

    /** Accepts any image. HEIC is no longer turned away at the door: browsers
     *  that can decode it just work, and the ones that cannot fail in the
     *  decoder with a message about THIS device rather than a blanket refusal
     *  aimed at every iPhone owner. */
    /** Loads the HEIC decoder once, only when a HEIC needs it. Same asset the
     *  deskmat customizer uses, so a customer who has seen one page has it
     *  cached for the other. */
    _loadHeicDecoder() {
      if (window.heic2any) return Promise.resolve(window.heic2any);
      if (this._heicLoader) return this._heicLoader;
      // MWCustomizer IS the element, so the attribute is read off itself.
      var src = this.getAttribute('data-heic-decoder-url');
      if (!src) return Promise.reject(new Error('no decoder url'));
      this._heicLoader = new Promise(function (res, rej) {
        var t = document.createElement('script');
        t.src = src;
        t.async = true;
        t.onload = function () { window.heic2any ? res(window.heic2any) : rej(new Error('decoder absent')); };
        t.onerror = function () { rej(new Error('decoder failed to load')); };
        document.head.appendChild(t);
      });
      return this._heicLoader;
    }

    /** Resolves to a file this browser can read. A non-HEIC, or a HEIC on
     *  Safari, comes back untouched — the decoder is never loaded for them. */
    _maybeConvertHeic(file) {
      var type = String(file.type || '').toLowerCase();
      var name = String(file.name || '').toLowerCase();
      var isHeic = type === 'image/heic' || type === 'image/heif' || /\.hei[cf]$/.test(name);
      if (!isHeic) return Promise.resolve(file);
      var self = this;
      return this._canDecodeNatively(file).then(function (ok) {
        if (ok) return file;
        self._setStatus('Converting your photo…');
        return self._loadHeicDecoder().then(function (convert) {
          return convert({ blob: file, toType: 'image/jpeg', quality: 0.95 });
        }).then(function (out) {
          var blob = Object.prototype.toString.call(out) === '[object Array]' ? out[0] : out;
          return new File([blob], file.name.replace(/\.hei[cf]$/i, '') + '.jpg', { type: 'image/jpeg' });
        });
      });
    }

    _canDecodeNatively(file) {
      if (typeof createImageBitmap !== 'function') return Promise.resolve(false);
      return createImageBitmap(file).then(function (b) {
        if (b && b.close) b.close();
        return true;
      }, function () { return false; });
    }

    _validatePhotoFile(file) {
      var name = String(file.name || '').toLowerCase();
      var type = String(file.type || '').toLowerCase();
      var looksImage = type.indexOf('image/') === 0 ||
        /\.(jpe?g|png|webp|avif|hei[cf]|gif|bmp|tiff?)$/.test(name);
      if (!looksImage) return 'Please choose an image file.';
      return null;
    }

    /** Decodes with EXIF orientation applied, downscaled so the longest side
     *  never exceeds the template's longest side. Always returns a canvas. */
    _decodePhoto(file) {
      var maxSide = Math.max(this._templateW, this._templateH);
      var toCanvas = function (source, sw, sh) {
        var scale = Math.min(1, maxSide / Math.max(sw, sh));
        var cv = document.createElement('canvas');
        cv.width = Math.max(1, Math.round(sw * scale));
        cv.height = Math.max(1, Math.round(sh * scale));
        cv.getContext('2d').drawImage(source, 0, 0, cv.width, cv.height);
        return cv;
      };
      var viaImg = function () {
        return new Promise(function (resolve, reject) {
          var url = URL.createObjectURL(file);
          var img = new Image();
          img.onload = function () {
            // Browsers apply EXIF orientation to <img> decode by default.
            var cv = toCanvas(img, img.naturalWidth, img.naturalHeight);
            URL.revokeObjectURL(url);
            resolve(cv);
          };
          img.onerror = function (e) {
            URL.revokeObjectURL(url);
            reject(e);
          };
          img.src = url;
        });
      };
      if (typeof createImageBitmap === 'function') {
        return createImageBitmap(file, { imageOrientation: 'from-image' })
          .then(function (bmp) {
            var cv = toCanvas(bmp, bmp.width, bmp.height);
            bmp.close();
            return cv;
          })
          .catch(viaImg);
      }
      return viaImg();
    }

    /** V1: ONE photo. Placing again replaces the previous one.
     *  Cover-fit + centre so the initial composition needs no adjustment. */
    _placePhoto(el) {
      var canvas = this.czCanvas;
      if (this._photoObj) {
        canvas.remove(this._photoObj);
        this._photoObj = null;
      }
      var art = this._art;
      var img = new window.fabric.FabricImage(el);
      var cover = Math.max(art.w / img.width, art.h / img.height);
      img.set({
        originX: 'center',
        originY: 'center',
        left: art.x + art.w / 2,
        top: art.y + art.h / 2,
        scaleX: cover,
        scaleY: cover,
        // Absolute floor so the image stays grabbable; Fabric enforces it in
        // its own corner-handle transform. Cover-fit is only the STARTING
        // composition — the customer is free to leave it.
        minScaleLimit: PHOTO_MIN_SCREEN_PX / Math.max(img.width, img.height)
      });
      this._applyControlStyle(img);
      img.clipPath = this._caseClip();
      this._coverScale = cover;

      canvas.add(img);
      canvas.sendObjectToBack(img);   // photo is always the bottom layer
      if (this._textObj) canvas.bringObjectToFront(this._textObj);
      this._bringGuidesToFront();
      canvas.setActiveObject(img);
      this._photoObj = img;
      this._showOverflow();      // _photoObj must be set first
      canvas.requestRenderAll();

      if (this._photoBtn) this._photoBtn.textContent = 'Replace Photo';
      if (this._zoomWrap) this._zoomWrap.hidden = false;
      if (this._hintEl) this._hintEl.hidden = false;
      this._updateDpiWarning();
      this._refreshAtcState();
      log('photo placed', { natural: img.width + 'x' + img.height, cover: cover.toFixed(4) });
    }

    _applyControlStyle(obj) {
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      obj.set({
        cornerStyle: 'circle',
        cornerColor: '#111111',
        cornerStrokeColor: '#ffffff',
        transparentCorners: false,
        borderColor: '#111111',
        cornerSize: coarse ? 28 : 22,   // >=24px touch targets on mobile
        touchCornerSize: 44,
        lockScalingFlip: true,
        lockSkewingX: true,
        lockSkewingY: true,
        centeredScaling: true,
        centeredRotation: true
      });
      obj.setControlsVisibility({ ml: false, mt: false, mr: false, mb: false });
    }

    /** Keeps the photo covering the whole artwork rect. Scale alone is not
     *  enough — dragging a cover-fit photo sideways exposes the other edge —
     *  so this pushes it back whenever a transform would leave the print area
     *  uncovered. Uses the bounding rect, so a rotated photo is held slightly
     *  more conservatively, which errs the safe way for print. */
    /** Zoom range for a photo, in canvas units. Derived from the image's own
     *  pixel size only — never from the case, so the case cannot constrain the
     *  transform. It decides visibility, nothing else. */
    _photoScaleBounds(obj) {
      var longest = Math.max(obj.width || 1, obj.height || 1);
      return {
        min: PHOTO_MIN_SCREEN_PX / longest,
        max: PHOTO_MAX_SCREEN_PX / longest
      };
    }

    _zoomActive(factor) {
      var canvas = this.czCanvas;
      if (!canvas) return;
      var obj = canvas.getActiveObject() || this._photoObj;
      if (!obj) return;
      var isPhoto = obj === this._photoObj;
      // A photo may never be shrunk below full coverage: anything less puts
      // white into the print file, which is what left the gaps at the top and
      // bottom of the case. It used to allow a quarter of cover.
      var lim = isPhoto ? this._photoScaleBounds(obj) : { min: 0.2, max: 10 };
      var min = lim.min, max = lim.max;
      var ratio = obj.scaleY / obj.scaleX;
      var s = Math.min(max, Math.max(min, obj.scaleX * factor));
      var centre = obj.getCenterPoint();
      obj.scaleX = s;
      obj.scaleY = s * ratio;
      obj.setPositionByOrigin(centre, 'center', 'center');
      obj.setCoords();
      if (isPhoto) this._syncOverflow();
      canvas.requestRenderAll();
      this._updateDpiWarning();
    }

    /* ------------- safe-area / camera guides (template-derived) ------------- */

    /** Guides derive from the mask asset's pixels — nothing hard-coded.
     *  They are UI-only: excludeFromExport keeps them out of every export. */
    _initGuides() {
      var self = this;
      if (!this.czConfig || !this.czConfig.mask_src) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var geom = null;
        try {
          geom = self._scanMask(img);
        } catch (err) {
          log('guide scan failed', err);
        }
        // Browsers with canvas-read protection (e.g. Edge strict tracking
        // prevention) return noisy/garbage pixel data — a corrupt scan puts
        // the bezel and clip in the wrong place. Sanity-check the geometry
        // and fall back to the known case-window fractions (UI-only values;
        // never used in print/export math).
        if (!self._geomLooksSane(geom)) {
          log('mask scan implausible, using fallback UI geometry', geom);
          geom = {
            sil: { x0: 0.0922, y0: 0, x1: 0.9078, y1: 1 },
            cam: { x0: 0.112, y0: 0.008, x1: 0.529, y1: 0.265 },
            radius: 0.137
          };
        }
        self._guideGeom = self._applyBleedToGeom(geom);
        self._createGuides();
        // A photo can be dropped before this async scan lands; those objects
        // were clipped to the print rectangle and are upgraded here.
        self._refreshClips();
      };
      img.onerror = function () { log('mask load failed (guides skipped)'); };
      img.src = this.czConfig.mask_src;
    }

    _geomLooksSane(g) {
      if (!g || !g.sil) return false;
      var s = g.sil;
      var symmetric = Math.abs((1 - s.x1) - s.x0) < 0.05;
      return s.y0 < 0.03 && s.y1 > 0.97 &&
        s.x0 > 0.04 && s.x0 < 0.2 && symmetric &&
        g.radius > 0.02 && g.radius < 0.25 &&
        (!g.cam || (g.cam.x1 < 0.65 && g.cam.y1 < 0.4));
    }

    /** Downsamples the silhouette mask and measures, as fractions of the
     *  template: the printable bbox, its corner radius, and the enclosed
     *  camera cutout (found as the transparent region NOT connected to the
     *  outside — corners flood away, the camera hole remains). */
    _scanMask(img) {
      var W = 120;
      var H = Math.max(2, Math.round(W * img.height / img.width));
      var cv = document.createElement('canvas');
      cv.width = W; cv.height = H;
      var ctx = cv.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, W, H);
      var d = ctx.getImageData(0, 0, W, H).data;
      var isIn = function (x, y) { return d[(y * W + x) * 4] > 127; };

      var x0 = W, y0 = H, x1 = -1, y1 = -1, x, y;
      for (y = 0; y < H; y++) {
        for (x = 0; x < W; x++) {
          if (isIn(x, y)) {
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
          }
        }
      }
      if (x1 < 0) throw new Error('mask empty');

      // flood the OUTSIDE over non-printable cells, starting from the borders
      var out = new Uint8Array(W * H);
      var stack = [];
      var push = function (px, py) {
        var i = py * W + px;
        if (px < 0 || py < 0 || px >= W || py >= H) return;
        if (out[i] || isIn(px, py)) return;
        out[i] = 1;
        stack.push(px, py);
      };
      for (x = 0; x < W; x++) { push(x, 0); push(x, H - 1); }
      for (y = 0; y < H; y++) { push(0, y); push(W - 1, y); }
      while (stack.length) {
        var cy = stack.pop(), cx = stack.pop();
        push(cx + 1, cy); push(cx - 1, cy); push(cx, cy + 1); push(cx, cy - 1);
      }

      var cx0 = W, cy0 = H, cx1 = -1, cy1 = -1, camCells = 0;
      for (y = 0; y < H; y++) {
        for (x = 0; x < W; x++) {
          if (!isIn(x, y) && !out[y * W + x]) {
            camCells += 1;
            if (x < cx0) cx0 = x;
            if (x > cx1) cx1 = x;
            if (y < cy0) cy0 = y;
            if (y > cy1) cy1 = y;
          }
        }
      }

      // corner radius ~ inset of the first printable pixel on the top row
      var lx = x1;
      for (x = x0; x <= x1; x++) { if (isIn(x, y0)) { lx = x; break; } }

      return {
        sil: { x0: x0 / W, y0: y0 / H, x1: (x1 + 1) / W, y1: (y1 + 1) / H },
        cam: camCells > 4
          ? { x0: cx0 / W, y0: cy0 / H, x1: (cx1 + 1) / W, y1: (cy1 + 1) / H }
          : null,
        radius: Math.max(0, (lx - x0) / W)
      };
    }

    _createGuides() {
      var g = this._guideGeom;
      var canvas = this.czCanvas;
      var art = this._art;
      if (!g || !canvas || !art) return;
      var mk = function (b, radiusFrac) {
        return new window.fabric.Rect({
          left: art.x + b.x0 * art.w,
          top: art.y + b.y0 * art.h,
          width: (b.x1 - b.x0) * art.w,
          height: (b.y1 - b.y0) * art.h,
          rx: radiusFrac * art.w,
          ry: radiusFrac * art.w,
          fill: '',
          stroke: '#111111',
          strokeDashArray: [6, 5],
          strokeWidth: 1.5,
          strokeUniform: true,
          opacity: 0.55,
          originX: 'left',
          originY: 'top',
          selectable: false,
          evented: false,
          excludeFromExport: true,
          visible: false
        });
      };
      // One safe-area line, inset inside the glass so it reads against the
      // photo (the mockup itself already shows the case edge and camera).
      var inset = (g.sil.x1 - g.sil.x0) * 0.045;
      this._guides = [mk({
        x0: g.sil.x0 + inset,
        y0: g.sil.y0 + inset * (art.w / art.h),
        x1: g.sil.x1 - inset,
        y1: g.sil.y1 - inset * (art.w / art.h)
      }, Math.max(0, g.radius - inset))];
      var self = this;
      this._guides.forEach(function (guide) { self.czCanvas.add(guide); });
      this._bringGuidesToFront();
      // Geometry is known now, so the in-case placeholder can be drawn.
      this._createPlaceholder();
      this._syncPlaceholder();
    }

    _bringGuidesToFront() {
      var canvas = this.czCanvas;
      if (!canvas || !this._guides) return;
      this._guides.forEach(function (guide) { canvas.bringObjectToFront(guide); });
    }

    _setGuidesVisible(visible) {
      var canvas = this.czCanvas;
      if (!canvas || !this._guides) return;
      this._guides.forEach(function (guide) { guide.visible = visible; });
      if (visible) this._bringGuidesToFront();
      canvas.requestRenderAll();
    }

    _handleResize() {
      var canvas = this.czCanvas;
      if (!canvas || !this._canvasDims || !this._art) return;
      var dims = this._computeCanvasSize();
      if (!dims.h || (dims.w === this._canvasDims.w && dims.h === this._canvasDims.h)) return;
      // The bands' clips are absolute, so they are rebuilt at the new size
      // rather than transformed. Entering edit mode resizes the stage, so
      // without restoring them the overflow vanished the moment it appeared.
      var overflowWas = !!this._overflow;
      this._hideOverflow();
      var oldArt = this._art;
      var newArt = { x: dims.g, y: dims.g, w: dims.artW, h: dims.artH };
      var factor = newArt.w / oldArt.w;
      // If the canvas was built while unmeasurable (0-size), factor is
      // Infinity/NaN — resizing is fine, but rescaling objects by it would
      // destroy the design. Size the canvas and skip object rescale.
      var rescaleObjects = isFinite(factor) && factor > 0;

      canvas.setDimensions({ width: dims.w, height: dims.h });
      this._art = newArt;
      this._positionMockup();

      var decor = (this._guides || []).slice();
      if (this._placeholder) decor.push(this._placeholder);
      if (rescaleObjects) {
        // Transform CONTENT relative to the ARTWORK region — the gutter is
        // clamped, not proportional, so canvas-relative scaling would drift.
        // Guides are rebuilt from geometry instead.
        canvas.getObjects().forEach(function (obj) {
          if (decor.indexOf(obj) !== -1) return;
          obj.set({
            left: newArt.x + (obj.left - oldArt.x) * factor,
            top: newArt.y + (obj.top - oldArt.y) * factor,
            scaleX: obj.scaleX * factor,
            scaleY: obj.scaleY * factor
          });
          obj.setCoords();
        });
        this._coverScale = (this._coverScale || 1) * factor;
      } else {
        log('object rescale skipped (previous size was 0)');
      }

      var self = this;
      canvas.getObjects().forEach(function (obj) {
        if (obj.clipPath && obj.clipPath.absolutePositioned) obj.clipPath = self._caseClip();
      });

      this._canvasDims = dims;
      this._syncStageBox(dims);
      this._rebuildDecor();
      if (overflowWas) this._showOverflow();
      canvas.requestRenderAll();
      log('resized canvas', dims);
    }

    /** Removes and re-creates guides from geometry at the current artwork
     *  size — deterministic, no incremental-transform drift. */
    _rebuildDecor() {
      var canvas = this.czCanvas;
      if (!canvas) return;
      var guidesWereVisible = !!(this._guides && this._guides.some(function (g) { return g.visible; }));
      if (this._guides) {
        this._guides.forEach(function (g) { canvas.remove(g); });
        this._guides = null;
      }
      if (this._placeholder) {
        canvas.remove(this._placeholder);
        this._placeholder = null;
      }
      if (this._guideGeom) {
        this._createGuides();   // also rebuilds the placeholder at the new size
        if (guidesWereVisible) this._setGuidesVisible(true);
      }
    }

    _debounce(fn, ms) {
      var t = null;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, ms);
      };
    }

    disconnectedCallback() {
      this._destroyed = true;
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onDocPointerDown) {
        document.removeEventListener('pointerdown', this._onDocPointerDown);
        this._onDocPointerDown = null;
      }
      if (this._onModalKey) {
        document.removeEventListener('keydown', this._onModalKey);
        this._onModalKey = null;
      }
      if (this._onEditKey) {
        document.removeEventListener('keydown', this._onEditKey);
        this._onEditKey = null;
      }
      if (this._onViewportResize && window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this._onViewportResize);
        window.visualViewport.removeEventListener('scroll', this._onViewportResize);
        this._onViewportResize = null;
      }
      document.body.classList.remove('mw-cz-typing');
      document.body.classList.remove('mw-cz-editing');
      if (this._touchTeardown) {
        this._touchTeardown();
        this._touchTeardown = null;
      }
      document.body.classList.remove('mw-cz-modal-open');
      if (this.czCanvas) {
        this.czCanvas.dispose();
        this.czCanvas = null;
      }
    }

    _setStatus(msg) {
      if (this._statusEl) this._statusEl.textContent = msg || '';
    }

    _fail(msg) {
      this._setStatus(msg);
      this.classList.add('mw-cz--error');
      if (this._loadingEl) this._loadingEl.textContent = msg;
      var atc = this.querySelector('[data-mw-cz-atc]');
      if (atc) atc.disabled = true;
    }
  }

  customElements.define('mw-customizer', MWCustomizer);
})();
